// Presentation editor UI: toolbars, panels, dialogs, properties, layers, etc.
const dict = {
  uk: {
    header: {
      saved: 'Збережено',
      saving: 'Зберігання',
      error: 'Помилка',
      preview: 'Попередній перегляд',
      aiGenerate: 'AI-урок',
    },
    ai: {
      title: 'Згенерувати урок з AI',
      modeFull: 'Вся презентація',
      modeSlide: 'Один слайд',
      topic: 'Тема уроку',
      topicPlaceholder: 'Напр. Past Simple, Food vocabulary, Daily routines',
      lessonTitle: 'Назва уроку (опційно)',
      lessonTitlePlaceholder: 'Напр. У кіно: що подивимось у вихідні?',
      lessonTitleHint: 'Якщо задано — AI поставить саме цю назву на титульний слайд.',
      level: 'Рівень',
      focus: 'Фокус',
      focusMixed: 'Змішаний',
      focusVocab: 'Лексика',
      focusGrammar: 'Граматика',
      focusReading: 'Читання',
      focusSpeaking: 'Говоріння',
      audienceType: 'Тип аудиторії',
      audienceKids: 'Діти',
      audienceAdults: 'Дорослі',
      audience: 'Деталі (опційно)',
      audiencePlaceholder: 'Напр. початківці, 8–10 років, бізнес-англійська',
      slidesCount: 'Кількість слайдів: {{count}}',
      extraContext: 'Додатковий контекст',
      extraContextHint: 'Що треба відпрацювати, список слів, нотатки — все, що допоможе AI.',
      extraContextPlaceholder: 'Напр. слова: apple, bread, cheese; відпрацювати \'there is / there are\'',
      references: 'Приклади слайдів (style references)',
      referencesHint: 'До 20 слайдів-референсів. AI збереже стиль (розкладку, елементи, кольори), а не вміст.',
      referencesAdd: 'Додати референс',
      referencesEmpty: 'Поки немає референсів. Додай слайди, стиль яких має наслідувати AI.',
      referencesRole: 'Роль у структурі уроку',
      referencesSearchPresentation: 'Знайти презентацію',
      referencesSearchPlaceholder: 'Назва презентації…',
      referencesSearchEmpty: 'Нічого не знайдено',
      referencesPickSlide: 'Номер слайда',
      referencesPickSlideHint: 'Можна кілька через кому, напр. 2, 5, 7',
      referencesBrowseSlides: 'Або обери слайди візуально',
      referencesSlidesLoadError: 'Не вдалося завантажити слайди',
      referencesAddButton: 'Додати',
      referencesRemove: 'Видалити',
      referencesLimit: 'Максимум 20 референсів',
      cancel: 'Скасувати',
      generate: 'Згенерувати',
      generating: 'Генерую...',
      generatingHint: 'Генерація може тривати до 10 хвилин. Не закривайте це вікно.',
    },
    toolbar: {
      undo: 'Скасувати (Ctrl+Z)',
      redo: 'Повторити (Ctrl+Shift+Z)',
      text: 'Текст (T)',
      shapes: 'Фігури (S)',
      rectangle: 'Прямокутник',
      square: 'Квадрат',
      circle: 'Коло',
      oval: 'Овал',
      triangle: 'Трикутник',
      messageBubble: 'Бульбашка',
      roundedMessageBubble: 'Бульбашка (заокруглена)',
      straightArrow: 'Стрілка — пряма (клікни і протягни)',
      curvedArrow: 'Стрілка — крива (намалюй від руки, вона згладиться)',
      image: 'Зображення (I)',
      video: 'Відео',
      youtubeVideo: 'YouTube-відео',
      audio: 'Аудіо',
      sound: 'Звук (короткий, без контролів)',
      elements: 'Елементи',
      exercises: 'Вправи',
      games: 'Ігри',
      stickers: 'Стікери',
      frames: 'Рамки (телефон, TV) — можна вставити відео',
      photos: 'Фото',
      grid: 'Сітка:',
      showGrid: 'Показати сітку',
      hideGrid: 'Приховати сітку',
      enableSnap: 'Увімкнути прив\'язку до сітки',
      disableSnap: 'Вимкнути прив\'язку до сітки',
      gridSize: 'Розмір сітки',
      enableSmartGuides: 'Увімкнути Smart Guides',
      disableSmartGuides: 'Вимкнути Smart Guides',
      zoom: 'Масштаб:',
      zoomOut: 'Зменшити масштаб',
      zoomLevel: 'Рівень масштабу',
      zoomIn: 'Збільшити масштаб',
      savedTemplates: 'Збережені ({{count}})',
      deleteTemplate: 'Видалити шаблон',
      deleteTemplateTitle: 'Видалити шаблон?',
      deleteTemplateMessage: 'Видалити шаблон "{{name}}"?',
      alignment: 'Вирівнювання',
      horizontal: 'Горизонтально',
      vertical: 'Вертикально',
      alignLeft: 'Ліворуч',
      alignCenter: 'По центру',
      alignRight: 'Праворуч',
      alignTop: 'Вгору',
      alignMiddle: 'По середині',
      alignBottom: 'Вниз',
      duplicate: 'Дублювати (Ctrl+D)',
      group: 'Групувати (Ctrl+G)',
      ungroup: 'Розгрупувати (Ctrl+Shift+G)',
      delete: 'Видалити',
      addSlide: 'Додати слайд',
    },
    elementsPanel: {
      searchPlaceholder: 'Пошук елементів...',
      interactive: 'Інтерактивні',
      exercises: 'Вправи',
      games: 'Ігри',
      items: {
        aliasGame: { name: 'Alias', description: 'Пояснюй слова партнеру за 1 хв — по черзі учень і вчитель' },
        tabooGame: { name: 'Taboo', description: 'Поясни слово, не вживаючи заборонених слів під ним' },
        whoAmIGame: { name: 'Who Am I?', description: 'Учень ставить yes/no питання, щоб вгадати картинку. Опційно — на час.' },
        inputField: { name: 'Поле вводу', description: 'Учні можуть вводити текст' },
        notebook: { name: 'Зошит', description: 'Учень пише на лініях — вчитель бачить у реальному часі' },
        spinWheel: { name: 'Колесо', description: 'Крутіть для випадкового вибору' },
        flipCard: { name: 'Flip-картка', description: 'Картка з двома сторонами' },
        dice: { name: 'Кубик', description: 'Кидайте кубик' },
        checkbox: { name: 'Чекбокс', description: 'Квадратик для галочки' },
        like: { name: 'Лайк', description: 'Сердечко — натисни, щоб зафарбувати' },
        rating: { name: 'Рейтинг', description: 'Ряд зірочок для оцінювання' },
        shop: { name: 'Магазин', description: 'Цінники на слайді — учень купує в межах бюджету' },
        cardDeck: { name: 'Колода карт', description: 'Дві колоди — учень перевертає верхню картку і кладе в сусідню' },
        book: { name: 'Книга', description: 'Учень натискає на обкладинку, гортає сторінки з текстом і зображеннями' },
        highlight: { name: 'Виділення', description: 'Учень натискає на місце на слайді — зʼявляється фігура (лінія, коло, овал, хрестик)' },
        smittnik: { name: 'Смітник', description: 'Перетягніть рухомі елементи в смітник — вони залишаться всередині' },
        bingo: { name: 'Бінго', description: 'Сітка квадратиків з текстом або фото — учень клацає, і клітинка перекреслюється' },
        memory: { name: 'Memory', description: 'Знайди пару: учень перевертає картки й шукає слово ↔ картинку' },
        personalityQuiz: { name: 'Тест', description: 'Питання по одному, учень обирає що ближче — у кінці результат («Яка ти принцеса?»)' },
        kissMarryAvoid: { name: 'Kiss / Marry / Avoid', description: 'Три персонажі — учень дає кожному Kiss, Marry або Avoid (кожну опцію лише раз)' },
        dressUp: { name: 'Одягалка', description: 'Персонаж і гардероб — учень обирає наряди та одягає персонажа' },
        boardGame: { name: 'Ходилка', description: 'Поле з клітинками-завданнями — гравці кидають кубик і ходять по черзі' },
        spotDifference: { name: 'Знайди відмінності', description: 'Дві картинки — учень клікає на відмінності, вони обводяться на обох' },
        mindMap: { name: 'Mind map', description: 'Тема в центрі — учень додає гілки та ідеї навколо' },
        dialogue: { name: 'Діалог-симулятор', description: 'Чат з персонажем — учень обирає репліки, від вибору залежить хід розмови' },
        pictionaryGame: { name: 'Pictionary', description: 'Малюй слово — інший вгадує. Учень ↔ вчитель або команди' },
        table: { name: 'Таблиця', description: 'Сітка з рядків і колонок' },
        puzzle: { name: 'Пазл', description: 'Учень збирає картинку з розкиданих пазлів у рамку' },
        singleChoice: { name: 'Один правильний', description: 'Оберіть одну правильну відповідь' },
        multipleChoice: { name: 'Кілька правильних', description: 'Оберіть всі правильні відповіді' },
        anagram: { name: 'Анаграма', description: 'Складіть слово з перемішаних літер' },
        wordsearch: { name: 'Wordsearch', description: 'З\'єднайте сусідні літери у сітці, щоб скласти слова' },
        boggle: { name: 'Boggle', description: 'З розкиданих літер складайте слова — сусідство не потрібне' },
        oddOneOut: { name: 'Зайве слово', description: 'У кожному рядку оберіть зайвий елемент' },
        sorting: { name: 'Сортування', description: 'Перетягни елементи у правильні категорії (таблиця чи корзинки)' },
        unjumble: { name: 'Скласти речення', description: 'Перетягни слова, щоб скласти речення у правильному порядку' },
        rank: { name: 'Ранжування', description: 'Учень виставляє елементи від першого до останнього (вертикально або горизонтально)' },
        orderSentences: { name: 'Порядок речень', description: 'Учень перетягує речення у стовпчику, щоб скласти їх у правильному порядку' },
        dragLabelImage: { name: 'Ярлики на картинку', description: 'Перетягни ярлики на правильні місця' },
        dragLabelText: { name: 'Ярлики у текст', description: 'Перетягни ярлики у пропуски в тексті' },
        dragLabelBlank: { name: 'Ярлики на слайд', description: 'Постав слоти будь-де і перетягуй ярлики з панелі' },
        matchLines: { name: 'Поєднай лініями', description: 'Учень з\'єднує пари крапок лініями' },
        labelImage: { name: 'Лінії на зображенні', description: 'Учень зʼєднує слова з крапками на зображенні' },
        typeAnswer: { name: 'Введіть відповідь', description: 'Учень друкує відповідь у поле' },
        trueFalse: { name: 'True / False', description: 'Учні пишуть T, F (або N) у квадратиках' },
        abcd: { name: 'ABCD', description: 'Питання з 2–4 варіантами — учень обводить правильний' },
        chooseWord: { name: 'Оберіть варіант', description: 'У реченні є два варіанти через / — учень обирає правильний' },
        fixMistake: { name: 'Виправ помилку', description: 'У реченні є помилка — учень клацає на слово і вписує правильний варіант' },
        fillGaps: { name: 'Заповніть пропуски', description: 'Учень друкує відповіді у пропуски в тексті' },
        tableFill: { name: 'Заповнення таблиці', description: 'Учень вписує відповіді у клітинки таблиці' },
        missingLetters: { name: 'Пропущені літери', description: 'У слові приховано деякі літери — учень вписує їх у порожні клітинки' },
        pronounce: { name: 'Озвучка', description: 'Учень вимовляє слово в мікрофон — точність вимови рахується як зірки' },
        findObject: { name: 'Знайди обʼєкт', description: 'Учень шукає названий обʼєкт на картинці й натискає на нього' },
        findSticker: { name: 'Знайди стікер', description: 'Розстав стікери на картинці — учень читає слово й натискає на потрібний стікер' },
        nmtImage: { name: 'НМТ картинка', description: 'Учень дивиться на картинку й обирає правильну відповідь із варіантів (A, B, C…)' },
      },
    },
    cardDeck: {
      title: 'Колода карт',
      subtitle: 'Учень натискає верхню картку — вона перевертається і переходить у сусідню колоду',
      cards: 'Картки',
      addCard: 'Додати',
      emptyHint: 'Додайте картки — вкажіть текст або зображення для лицьового і зворотного боку.',
      removeCard: 'Видалити картку',
      front: 'Лице',
      back: 'Зворот',
      textPlaceholder: 'Текст',
      uploadImage: 'Фото',
      fontSize: 'Розмір тексту',
      colors: 'Кольори',
      frontBg: 'Лице · фон',
      frontText: 'Лице · текст',
      backBg: 'Зворот · фон',
      backText: 'Зворот · текст',
    },
    book: {
      title: 'Книга',
      subtitle: 'Учень натискає на обкладинку — книга відкривається; натискає на сторінку — вона перегортається',
      cover: 'Обкладинка',
      coverTitlePlaceholder: 'Назва книги',
      coverDefault: 'Моя книга',
      coverBg: 'Фон',
      coverText: 'Текст',
      pages: 'Сторінки',
      addPage: 'Додати',
      pageLabel: 'Сторінка',
      textPlaceholder: 'Текст сторінки',
      uploadImage: 'Фото',
      moveUp: 'Вгору',
      moveDown: 'Вниз',
      removePage: 'Видалити сторінку',
      emptyHint: 'Додайте сторінки — вкажіть текст або зображення для кожної.',
      editorEmpty: 'Додайте сторінки у панелі властивостей праворуч',
      fontSize: 'Розмір тексту',
      coverFontSize: 'Розмір тексту обкладинки',
      pageFontSize: 'Розмір тексту сторінок',
      coverFont: 'Шрифт обкладинки',
      pageFont: 'Шрифт сторінок',
      pageColor: 'Фон сторінки',
      textColor: 'Колір тексту',
      bold: 'Жирний',
      italic: 'Курсив',
      alignLeft: 'Вирівняти зліва',
      alignCenter: 'Вирівняти посередині',
      alignRight: 'Вирівняти справа',
    },
    highlight: {
      shape: 'Фігура виділення',
      color: 'Колір',
      strokeWidth: 'Товщина лінії',
      hint: 'Учень натисне на елемент — фігура зʼявиться. Натисне ще раз — зникне.',
      shapes: {
        underline: 'Підкреслення',
        circle: 'Коло',
        oval: 'Овал',
        cross: 'Хрестик',
      },
    },
    bingo: {
      title: 'Бінго',
      subtitle: 'Сітка з квадратиків — учень натискає на квадратик, і він перекреслюється',
      rows: 'Рядків',
      cols: 'Колонок',
      cells: 'Квадратики',
      cellPlaceholder: 'Текст',
      uploadImage: 'Фото',
      fontSize: 'Розмір тексту',
      font: 'Шрифт',
      cellBg: 'Фон клітинки',
      textColor: 'Колір тексту',
      borderColor: 'Колір рамки',
      crossColor: 'Колір хрестика',
      borderWidth: 'Товщина рамки',
    },
    stickerPanel: {
      searchPlaceholder: 'Пошук стікерів...',
      notFound: 'Стікерів не знайдено',
      empty: 'Немає стікерів',
      addInAdmin: 'Додайте стікери в адмін-панелі',
    },
    framePanel: {
      title: 'Рамки',
      subtitle: 'Всередину можна вставити фото або відео',
      empty: 'Немає рамок',
      addInAdmin: 'Додайте рамки в адмін-панелі',
    },
    photoPanel: {
      searchPlaceholder: 'Пошук фото...',
      notFound: 'Фото не знайдено',
      empty: 'Немає фото',
      addInAdmin: 'Додайте фото в адмін-панелі',
    },
    colorPicker: {
      transparent: 'Прозорий',
      eyedropper: 'Піпетка — обрати колір з екрана',
    },
    saveTemplate: {
      title: 'Зберегти як шаблон',
      slide: 'Слайд {{index}}',
      nameLabel: 'Назва шаблону',
      namePlaceholder: 'Наприклад: Вітальний слайд, Вправа на matching...',
    },
    starThresholds: {
      title: 'Зірочки за кількість слів',
      wordsFound: 'Знайдено слів (≥)',
      stars: 'Зірочок',
      note: 'Учень отримує стільки зірок, у скільки тір потрапляє за кількістю знайдених слів. 0 слів — 0 зірок.',
    },
    layers: {
      title: 'Шари',
      empty: 'На слайді немає елементів',
      hint: 'Верхній рядок — передній план. Перетягуй, щоб змінити порядок.',
      childrenCount: '{{count}} елементів',
      elementFallback: 'Елемент',
    },
    textStyle: {
      title: 'Стиль тексту',
      size: 'Розмір',
      color: 'Колір',
      pickColor: 'Обрати колір тексту',
    },
    canvas: {
      dropFile: 'Перетягніть файл сюди',
      dropFileHint: 'Зображення, відео або аудіо',
      dropIntoFrame: 'Відпустіть, щоб вставити у рамку',
      rotate: 'Обертати',
      lock: 'Заблокувати положення',
      unlock: 'Розблокувати',
      group: 'Група ({{count}})',
      linkToSlide: 'Слайд',
      emptySlide: 'Порожній слайд',
    },
    elementLabels: {
      text: 'Текст',
      shape: 'Фігура',
      arrow: 'Стрілка',
      image: 'Зображення',
      video: 'Відео',
      youtubeVideo: 'YouTube',
      audio: 'Аудіо',
      sound: 'Звук',
      sticker: 'Стікер',
      group: 'Група',
      table: 'Таблиця',
      inputField: 'Поле вводу',
      notebook: 'Зошит',
      spinWheel: 'Колесо',
      flipCard: 'Flip-картка',
      dice: 'Кубик',
      checkbox: 'Чекбокс',
      like: 'Лайк',
      rating: 'Рейтинг',
      shop: 'Магазин',
      cardDeck: 'Колода карт',
      book: 'Книга',
      highlight: 'Виділення',
      memory: 'Memory',
      personalityQuiz: 'Тест',
      kissMarryAvoid: 'Kiss / Marry / Avoid',
      dressUp: 'Одягалка',
      boardGame: 'Ходилка',
      spotDifference: 'Знайди відмінності',
      mindMap: 'Mind map',
      dialogue: 'Діалог-симулятор',
      singleChoice: 'Один правильний',
      multipleChoice: 'Кілька правильних',
      anagram: 'Анаграма',
      aliasGame: 'Alias',
      whoAmIGame: 'Who Am I?',
      oddOneOut: 'Зайве слово',
      sorting: 'Сортування',
      unjumble: 'Скласти речення',
      rank: 'Ранжування',
      orderSentences: 'Порядок речень',
      dragLabelImage: 'Ярлики на картинку',
      dragLabelText: 'Ярлики у текст',
      dragLabelBlank: 'Ярлики на слайд',
      matchLines: 'Поєднай лініями',
      labelImage: 'Лінії на зображенні',
      typeAnswer: 'Введіть відповідь',
      chooseWord: 'Оберіть варіант',
      fixMistake: 'Виправ помилку',
      fillGaps: 'Заповніть пропуски',
      tableFill: 'Заповнення таблиці',
      missingLetters: 'Пропущені літери',
      pronounce: 'Озвучка',
      nmtImage: 'НМТ картинка',
    },
    properties: {
      title: 'Властивості',
      slideTitle: 'Властивості слайда',
      settings: 'Налаштування',
      appearance: 'Вигляд',
      behavior: 'Поведінка',
      backgroundColor: 'Колір фону',
      readyGradients: 'Готові градієнти',
      gradient: 'Градієнт',
      opacity: 'Прозорість',
      rotation: 'Обертання',
      borderRadius: 'Закруглення кутів',
      cloneOnDrag: 'Клонувати при перетягуванні',
      cloneOnDragHint: 'Учень може перетягувати копії; оригінал лишається на місці',
      gifPlayback: 'Відтворення GIF',
      gifPlaybackLoop: 'Зациклити',
      gifPlaybackLoopHint: 'Грає постійно, поки відкритий слайд',
      gifPlaybackClick: 'За натисканням',
      gifPlaybackClickHint: 'Відтворюється, коли вчитель натискає на гіфку',
      gifPlaybackSlide: 'При відкритті слайда',
      gifPlaybackSlideHint: 'Відтворюється один раз, коли вмикається слайд',
      filtersSection: 'Фільтри зображення',
      filtersReset: 'Скинути',
      filterBrightness: 'Яскравість',
      filterContrast: 'Контраст',
      filterSaturation: 'Насиченість',
      filterHue: 'Відтінок',
      filterBlur: 'Розмиття',
      filterSepia: 'Сепія',
      filterGrayscale: 'Чорно-білий',
      strokeWidth: 'Товщина обводки',
      strokeColor: 'Колір обводки',
      fill: 'Заливка',
      stroke: 'Обводка',
      backgroundElement: 'Фоновий елемент',
      teacherOnly: 'Видно лише вчителю під час уроку',
      showLayers: 'Показати шари',
      showLayersPanel: 'Показати панель шарів',
      hint: 'Підказки, тайминги, відповіді…',
      selectionCount: 'Вибрано {{count}} елементів',
      group: 'Група',
      groupBtn: 'Групувати',
      ungroupBtn: 'Розгрупувати',
      layer: 'Шар',
      toFront: 'На передній план',
      toBack: 'На задній план',
      moveForward: 'Перемістити вперед (на один шар вище)',
      moveBackward: 'Перемістити назад (на один шар нижче)',
      shapeType: 'Тип фігури',
      color1: 'Колір 1',
      color2: 'Колір 2',
      glowColor: 'Колір світіння',
      elementBackground: 'Фон елемента',
      font: 'Шрифт',
      fontSize: 'Розмір шрифту',
      textColor: 'Колір тексту',
      bold: 'Жирний',
      italic: 'Курсив',
      lineHeight: 'Відстань між рядками',
      bulletedList: 'Маркований список',
      numberedList: 'Нумерований список',
      alignment: 'Вирівнювання',
      alignLeft: 'Ліворуч',
      alignCenter: 'По центру',
      alignRight: 'Праворуч',
      horizontal: 'Горизонтальний',
      vertical: 'Вертикальний',
      leftToRight: 'Зліва направо',
      rightToLeft: 'Справа наліво',
      topToBottom: 'Зверху вниз',
      bottomToTop: 'Знизу вгору',
      diagTopLeft: 'По діагоналі вліво-вгору',
      diagTopRight: 'По діагоналі вправо-вгору',
      diagBottomLeft: 'По діагоналі вліво-вниз',
      diagBottomRight: 'По діагоналі вправо-вниз',
      flip: 'Відзеркалення',
      flipHorizontal: 'Відзеркалити горизонтально',
      flipVertical: 'Відзеркалити вертикально',
      perspective: 'Перспектива',
      perspectiveVertical: 'Вертикально',
      perspectiveHorizontal: 'Горизонтально',
      resetPerspective: 'Скинути перспективу',
      lists: 'Списки',
      strokeWidthLine: 'Товщина лінії',
      headSize: 'Розмір наконечника',
      videoSettings: 'Налаштування відео',
      autoplay: 'Автовідтворення',
      autoplayMuted: 'Автовідтворення (з вимкненим звуком)',
      muted: 'Без звуку',
      loop: 'Зациклити',
      selectFile: 'Обрати файл',
      selectVideoOrPhoto: 'Обрати відео або фото',
      replaceFile: 'Замінити файл',
      uploadImage: 'Завантажити зображення',
      uploadAudio: 'Завантажити аудіо',
      uploadVideo: 'Завантажити відео',
      uploadSound: 'Завантажити звук',
      deleteSound: 'Видалити звук',
      soundAdded: 'Звук додано',
      or: 'або',
      orDragHere: 'або перетягни сюди',
      allowedFormatsImage: 'Дозволені формати: JPEG, PNG, GIF, WebP',
      allowedFormatsAudio: 'Дозволені формати: MP3, WAV, OGG, M4A',
      maxFileSize: 'Максимальний розмір файлу: 20MB',
      loading: 'Завантаження…',
      loadingDots: 'Завантаження...',
      invalidFormat: 'Невірний формат',
      fileTooLarge: 'Файл занадто великий',
      soundTooLong: 'Звук задовгий',
      cannotReadAudio: 'Не вдалось прочитати аудіофайл',
      uploadImageError: 'Помилка завантаження зображення',
      uploadSoundError: 'Помилка завантаження звуку',
      diceType: 'Тип кубика',
      diceColor: 'Колір кубика',
      dotsColor: 'Колір точок/цифр',
      spinDurationMs: 'Тривалість обертання (мс)',
      inputType: 'Тип поля',
      singleLineText: 'Текст (один рядок)',
      multiLineText: 'Текст (багато рядків)',
      maxChars: 'Макс. символів',
      studentCanEdit: 'Учні можуть редагувати',
      studentCanDrag: 'Учні можуть перетягувати',
      flipDirection: 'Напрямок перевертання',
      front: 'Передня сторона',
      back: 'Задня сторона',
      frontText: 'Текст передньої сторони...',
      backText: 'Текст задньої сторони...',
      chooseFromStickers: 'Обрати зі стікерів',
      hintText: 'Текст підказки...',
      checkColor: 'Колір галочки',
      heartColor: 'Колір сердечка',
      starColor: 'Колір зірочок',
      starCount: 'Кількість зірочок',
      cellBg: 'Фон клітинок',
      headerBg: 'Фон заголовка',
      headerColor: 'Колір заголовка',
      headerText: 'Текст заголовка',
      firstRowHeader: 'Перший рядок — заголовок',
      rows: 'Рядки ({{count}})',
      columns: 'Колонки ({{count}})',
      always: 'Завжди',
      clickOnly: 'Клік / вимк',
      clickNoOff: 'Клік без вимк',
      collapse: 'Згорнути',
      expand: 'Розгорнути',
      enable: 'Увімкнути',
      addTag: 'Додайте принаймні один ярлик',
      addTwoPairs: 'Додайте принаймні дві пари',
      addFrames: 'Додайте рамки',
      addLetters: 'Додайте літери',
      wordsMissingLetters: 'Деяким словам не вистачає літер у пулі. Додайте літери або заміни слова.',
      wordsNotFormable: 'Деякі слова не складаються із цієї сітки. Перевір літери або заміни слова.',
      pair: 'Пара #{{index}}',
      allowRetry: 'Дозволити повторну спробу',
      retry: 'Повторна спроба',
      pointDot: 'Точка',
      onTime: 'На час',
      accuracyThreshold: 'Точність (0.0–1.0) ≥',
      findWholeWords: 'Знайти цілі',
      variantNo: 'Варіант "N" (no information)',
      poolPosition: 'Розташування пулу елементів',
      letters: 'Літери',
      doubleClickToEdit: 'Двічі клацніть текст, щоб редагувати',
      pickFile: 'Обрати файл',
      // Extended properties keys for PropertiesPanel
      slideLink: 'Перехід до слайда',
      slideOption: 'Слайд {{index}}',
      removeSlideLink: 'Видалити посилання',
      addSlideLink: '+ Додати перехід на слайд',
      selectionHint: 'Параметри показані лише для першого. Доступні групові дії: переміщення, Delete, Ctrl+D (дублювати), Ctrl+G (групувати).',
      groupSelected: 'Групувати',
      groupTooltip: 'Групувати (Ctrl+G)',
      ungroupTooltip: 'Розгрупувати (Ctrl+Shift+G)',
      fixed: 'Fixed',
      movable: 'Movable',
      editable: 'Editable',
      highlight: 'Підсвітка',
      textStyle: 'Стиль тексту',
      shapeRectangle: 'Прямокутник',
      shapeSquare: 'Квадрат',
      shapeCircle: 'Коло',
      shapeOval: 'Овал',
      shapeTriangle: 'Трикутник',
      shapeMessageBubble: 'Бульбашка повідомлення',
      shapeRoundedMessageBubble: 'Бульбашка (заокруглена)',
      allowedFormatsImageWithSize: 'JPEG, PNG, GIF, WebP (макс. 5MB)',
      allowedFormatsVideoWithSize: 'MP4, WebM, OGG (макс. 500MB)',
      allowedFormatsAudioWithSize: 'MP3, WAV, OGG (макс. 20MB)',
      videoUrl: 'URL відео',
      youtubeUrl: 'YouTube URL',
      youtubeInvalidUrl: 'Не вдалося розпізнати відео. Вставте посилання виду https://www.youtube.com/watch?v=... або https://youtu.be/...',
      audioUrl: 'URL аудіо',
      frameMedia: 'Медіа у рамці',
      frameMediaFormats: 'Відео: MP4/WebM (до 500MB) · Фото: JPG/PNG/WebP (до 20MB)',
      deleteFrameMedia: 'Видалити медіа з рамки',
      frameMediaPosition: 'Положення медіа',
      frameMediaAdjust: 'Налаштувати положення',
      frameMediaAdjustDone: 'Готово',
      frameMediaAdjustHint: 'Тягніть, щоб перемістити · Прокрутка — масштаб',
      frameMediaZoom: 'Масштаб',
      frameMediaReset: 'Скинути',
      frameVideoTrim: 'Обрізати відео',
      frameVideoTrimStart: 'Початок',
      frameVideoTrimEnd: 'Кінець',
      frameVideoTrimDuration: 'Тривалість',
      frameVideoTrimLoading: 'Завантаження тривалості…',
      soundFormatsShort: 'MP3, WAV, OGG. До {{seconds}} с. Без перемотки і паузи.',
      soundFormatsHint: 'До {{seconds}} с. Без перемотки і паузи — програється натисканням іконки.',
      sound: 'Звук',
      placeholderLabel: 'Placeholder',
      hintTextPlaceholder: 'Текст підказки...',
      notebookTitle: 'Заголовок (необов\'язково)',
      notebookTitlePlaceholder: 'Наприклад: Домашнє завдання',
      notebookLineSpacing: 'Висота лінійки (px)',
      notebookLineColor: 'Колір ліній',
      segments: 'Сегменти ({{count}}/12)',
      optionPlaceholder: 'Варіант {{index}}',
      optionText: 'Варіант {{index}}',
      addOption: '+ Додати варіант',
      resetRotation: 'Скинути обертання',
      teacherNotes: 'Нотатки для вчителя',
      teacherNotesVisibility: 'Видно лише вчителю під час уроку',
      teacherNotesPlaceholder: 'Підказки, тайминги, відповіді…',
      teacherNotesBold: 'Жирний',
      teacherNotesItalic: 'Курсив',
      teacherNotesBulletList: 'Маркований список',
      teacherNotesNumberedList: 'Нумерований список',
      teacherNotesImage: 'Додати фото',
      gradientDirection: 'Напрямок',
      gradientPresetPurple: 'Фіолетовий',
      gradientPresetGreen: 'Зелений',
      gradientPresetPink: 'Рожевий',
      gradientPresetSunset: 'Захід',
      gradientPresetBlue: 'Блакитний',
      gradientPresetCoral: 'Коралловий',
      gradientPresetPeach: 'Персиковий',
      gradientPresetPastel: 'Пастельний',
      invalidFormatTitle: 'Невірний формат',
      fileTooLargeTitle: 'Файл занадто великий',
      errorTitle: 'Помилка',
      soundTooLongTitle: 'Звук задовгий',
      soundMaxDuration: 'Максимальна тривалість: {{seconds}} секунд',
      failedReadAudio: 'Не вдалось прочитати аудіофайл',
      soundUploadError: 'Помилка завантаження звуку',
      imageUploadError: 'Помилка завантаження зображення',
      allowedFormatsAudioList: 'Дозволені формати: MP3, WAV, OGG, M4A',
      maxFileSize10MB: 'Максимальний розмір файлу: 20MB',
      allowedFormatsImageList: 'Дозволені формати: JPEG, PNG, GIF, WebP',
    },
    configPanels: {
      common: {
        allowRetryTitle: 'Повторна спроба',
        allowRetryOn: 'Учень може спробувати ще раз',
        allowRetryOff: 'Лише одна спроба',
        pickColor: 'Обрати колір',
        transparent: 'Прозорий',
        actionBarButton: 'Фон панелі з кнопкою "Перевірити"',
        actionBarBg: 'Фон панелі з кнопкою',
        actionBarPickTransparent: 'Оберіть прозорий або власний колір',
        colorPresetGreen: 'Зелений',
        colorPresetIndigo: 'Індіго',
        colorPresetTeal: 'Бірюзовий',
        colorPresetRed: 'Червоний',
        colorPresetOrange: 'Помаранчевий',
        colorPresetPurple: 'Фіолетовий',
        colorPresetDarkGreen: 'Темно-зелений',
        tileColor: 'Колір плиток',
        checkButtonColor: 'Колір кнопки "Перевірити"',
        font: 'Шрифт',
        textSize: 'Розмір тексту ({{size}}px)',
        deleteBtn: 'Видалити',
        deleteImage: 'Видалити зображення',
        addLabel: 'Додати',
        correctLabelPlaceholder: '— правильний ярлик —',
        slots: 'Слоти ({{count}})',
        labels: 'Ярлики ({{count}})',
        labelText: 'Текст ярлика',
        addAtLeastOneLabel: 'Додайте принаймні один ярлик',
        extraLabel: 'зайвий',
        extraLabelTooltip: 'Цей ярлик ні до якого слота не приʼязаний — буде як зайвий',
        deleteSlot: 'Видалити слот',
        slotWidth: 'Ш',
        slotHeight: 'В',
        slotSize: 'розмір',
        paletteSide: 'Розташування палітри',
        paletteTop: 'Зверху',
        paletteBottom: 'Знизу',
        paletteLeft: 'Зліва',
        paletteRight: 'Справа',
        uploadingImage: 'Завантаження…',
        dropToUpload: 'Відпусти, щоб завантажити',
        uploadImage: 'Завантажити зображення',
        orDragHere: 'або перетягни сюди',
        uploadFailed: 'Помилка завантаження',
        uploadImageFailed: 'Не вдалось завантажити зображення',
        serverNoImageUrl: 'Сервер не повернув imageUrl',
        invalidFormat: 'Невірний формат',
        allowedFormatsImage: 'Дозволені формати: JPEG, PNG, GIF, WebP',
        fileTooLarge: 'Файл завеликий',
        maxSize10MB: 'Максимальний розмір: 20MB',
        dragToReorder: 'Перетягніть, щоб змінити порядок',
        instruction: 'Інструкція (не обовʼязково)',
        correct: 'Правильно:',
        addAtLeastOneSentence: 'Додайте хоча б одне речення',
      },
      anagram: {
        title: 'Анаграма',
        subtitle: 'Учень має скласти слово з перемішаних літер',
        wordLabel: 'Слово для відгадування',
        wordPlaceholder: 'Введіть слово...',
        wordHint: 'Максимум 12 літер. Літери будуть перемішані автоматично.',
        preview: 'Попередній перегляд',
        hintLabel: 'Підказка (необовʼязково)',
        hintPlaceholder: 'Наприклад: Місяць року',
        validationMinLetters: 'Введіть слово (мінімум 2 літери)',
      },
      alias: {
        title: 'Alias',
        subtitle: 'Учень і вчитель по черзі пояснюють слова партнеру за 1 хвилину. Скільки слів вийде?',
        addWordLabel: 'Додати слово',
        addWordPlaceholder: 'Слово або фраза',
        addButton: 'Додати',
        bulkHint: 'Можна вставити багато слів через кому або з нового рядка.',
        importFromFile: 'Імпорт з файлу',
        importSuccess: 'Додано {{added}} слів з файлу.',
        importSuccessTruncated: 'Додано {{added}} слів. Ще {{dropped}} пропущено (ліміт 1000 за раз).',
        importEmpty: 'У файлі не знайдено слів.',
        importReadError: 'Не вдалося прочитати файл.',
        pasteListButton: 'Вставити список',
        pasteListPlaceholder: 'Вставте слова: по одному на рядок або через кому/крапку з комою',
        pastePreview: 'Буде додано: {{count}}',
        pasteAddAll: 'Додати всі',
        pasteCancel: 'Скасувати',
        wordsLabel: 'Слова',
        emptyList: 'Ще немає слів. Додайте хоча б одне, щоб гра запрацювала.',
        removeWord: 'Видалити слово',
        validationEmpty: 'Додайте хоча б одне слово, щоб зберегти гру.',
        recommendation: 'Рекомендуємо 10+ слів для повноцінної гри на 2 хвилини.',
      },
      taboo: {
        title: 'Taboo',
        subtitle: 'Учень і вчитель по черзі пояснюють слова за 1 хвилину, не вживаючи заборонених слів під ними.',
        addCard: 'Додати картку',
        wordPlaceholder: 'Слово, яке треба пояснити',
        forbiddenPlaceholder: 'Заборонені слова через кому',
        removeCard: 'Видалити картку',
        pasteListButton: 'Вставити список',
        pasteHint: 'Одна картка на рядок: слово, двокрапка, заборонені слова через кому.',
        pastePreview: 'Буде додано карток: {{count}}',
        pasteAddAll: 'Додати всі',
        pasteCancel: 'Скасувати',
        importSuccess: 'Додано карток: {{added}}.',
        importSuccessTruncated: 'Додано {{added}} карток. Ще {{dropped}} пропущено (ліміт 500 за раз).',
        cardsLabel: 'Картки',
        emptyList: 'Ще немає карток. Додайте хоча б одну, щоб гра запрацювала.',
        validationEmpty: 'Додайте хоча б одну картку зі словом.',
        missingForbidden: 'У деяких картках немає заборонених слів.',
        recommendation: 'Рекомендуємо 10+ карток для повноцінної гри на 2 хвилини.',
      },
      boggle: {
        title: 'Wordsearch',
        subtitle: 'Учень зʼєднує сусідні літери у сітці, щоб скласти слова.',
        gameMode: 'Режим гри',
        modeTargets: 'Знайти цілі',
        modeTime: 'На час',
        modeTargetsHint: 'Учень повинен знайти всі цілі. Інші слова зарахуються як «бонус».',
        modeTimeHint: 'Учень шукає якомога більше слів за відведений час.',
        gridSize: 'Розмір сітки',
        letters: 'Літери',
        random: 'Випадкові',
        regenerate: 'Перегенерувати',
        wordTooLong: 'Слово «{{word}}» задовге для сітки. Збільшіть розмір сітки.',
        gridTooCrowded: 'Слова не вміщуються в сітку. Збільшіть розмір сітки.',
        targetWords: 'Слова для пошуку',
        wordInputPlaceholder: 'Введіть слово...',
        wordFindable: 'Можна скласти зі сітки',
        wordNotFindable: 'Не вдається скласти зі сітки',
        someUnfindable: 'Деякі слова не складаються із цієї сітки. Перевір літери або заміни слова.',
        timeLimit: 'Час на гру',
        timeSec: 'сек',
        timeMin: 'хв',
        timeHintMin: 'Від 1 до 60 хвилин. Таймер стартує з першим кліком учня.',
        timeHintSec: 'Від 10 до 3600 секунд. Таймер стартує з першим кліком учня.',
        minWordsToPass: 'Мінімум слів для «зараховано»',
        minWordsHint: 'Якщо учень знайде стільки чи більше слів, результат буде позитивним.',
        addAtLeastOneWord: 'Додайте хоча б одне слово для пошуку',
      },
      chooseWord: {
        title: 'Оберіть варіант',
        subtitle: 'У квадратних дужках пишіть два варіанти через /. Приклад:',
        instructionPlaceholder: 'Напр. Оберіть правильний варіант',
        sentences: 'Речення',
        sentencePlaceholder: 'I [go/goes] to school every day.',
        deleteSentence: 'Видалити',
        addSentence: 'Додати речення',
        addOptionsFormat: 'Додайте варіанти у форматі',
        highlightColor: 'Колір обведення варіанту',
        selectedFillColor: 'Заливка вибраного варіанту',
        selectedTextColor: 'Колір тексту вибраного варіанту',
      },
      fixMistake: {
        title: 'Виправ помилку',
        subtitle: 'Загорніть неправильне слово у квадратні дужки, через | вкажіть правильний варіант. Кілька правильних варіантів — теж через |. Приклад:',
        instructionPlaceholder: 'Напр. Знайдіть і виправте помилку',
        sentences: 'Речення',
        deleteSentence: 'Видалити',
        addSentence: 'Додати речення',
        addMistakeFormat: 'Позначте помилку у форматі',
        mistake: 'Помилка',
        noCorrection: 'Додайте правильний варіант через |',
        hint: 'Учень бачить речення без підказок — клацає на слово, яке вважає помилкою, і вписує виправлення.',
        highlightColor: 'Колір виділення виправленого слова',
      },
      dragLabelBlank: {
        title: 'Ярлики на слайд',
        subtitle: 'Постав слоти будь-де на слайді. Учні перетягують ярлики з панелі.',
        slotPlacement: 'Розстановка слотів',
        clickToAddSlot: 'Клікніть, щоб додати слот',
        placeholderLabel: '+ ярлик',
        placementHint: 'Клікніть на превʼю слайду, щоб додати слот. Перетягуйте, щоб переставити.',
        labelTextStyle: 'Стиль тексту ярликів',
        labelColor: 'Колір ярликів',
        labelTextColor: 'Колір тексту ярликів',
        slotColor: 'Колір слотів',
        paletteColor: 'Колір панелі відповідей',
      },
      dragLabelImage: {
        title: 'Перетягни ярлики на картинку',
        subtitle: 'Учень тягне ярлики на потрібні місця на зображенні',
        image: 'Зображення',
        placementHint: 'Клікніть на картинку, щоб додати слот. Перетягуйте слоти, щоб переставити.',
        cropHint: 'Тягни прямокутник, щоб обрізати картинку. Кутики змінюють розмір.',
        placeholderLabel: '+ ярлик',
        done: 'Готово',
        cancel: 'Скасувати',
        crop: 'Обрізати',
        resetCrop: 'Скинути обрізку',
        changeImage: 'Змінити',
        deleteImage: 'Видалити',
        paletteSideLabel: 'Розташування палітри',
        labelTextStyle: 'Стиль тексту ярликів',
        labelColor: 'Колір ярликів',
        labelTextColor: 'Колір тексту ярликів',
        slotColor: 'Колір слотів',
      },
      nmtImage: {
        title: 'НМТ картинка',
        subtitle: 'Завантаж картинки і додай варіанти відповідей (A, B, C…). Для кожної картинки обери правильну.',
        options: 'Варіанти відповідей ({{count}})',
        addOption: 'Додати варіант',
        addAtLeastTwoOptions: 'Додай щонайменше два варіанти відповідей',
        questions: 'Картинки ({{count}})',
        addImage: 'Додати картинку',
        addFirstImage: 'Натисни «Додати картинку», щоб завантажити першу.',
        imageNumber: 'Картинка #{{index}}',
        replaceImage: 'Замінити картинку',
        promptPlaceholder: 'Питання або підказка (не обовʼязково)',
        correctAnswer: 'Правильна відповідь',
        noCorrectAnswer: '— оберіть варіант —',
        needCorrect: 'Обери правильний варіант для цієї картинки',
        correctIs: 'Правильно: {{letter}}',
        buttonColor: 'Колір кнопок',
      },
      findObject: {
        title: 'Знайди обʼєкт',
        subtitle: 'Завантаж картинку і клікай на обʼєкти, які треба знайти. Для кожного впиши слово.',
        image: 'Зображення',
        placementHint: 'Клікніть на картинку, щоб додати обʼєкт. Точки можна перетягувати.',
        clickImageToAdd: 'Клікніть на картинку, щоб додати перший обʼєкт.',
        cropHint: 'Тягни прямокутник, щоб обрізати картинку. Кутики змінюють розмір.',
        done: 'Готово',
        cancel: 'Скасувати',
        crop: 'Обрізати',
        resetCrop: 'Скинути обрізку',
        changeImage: 'Змінити',
        deleteImage: 'Видалити',
        objects: 'Обʼєкти ({{count}})',
        wordPlaceholder: 'напр. apple',
        radius: 'Радіус',
        wordTextStyle: 'Стиль тексту слова',
        wordBgColor: 'Колір фону слова',
        shuffleTitle: 'Перемішувати порядок',
        shuffleOn: 'Порядок пошуку — випадковий',
        shuffleOff: 'Порядок пошуку — як у списку',
      },
      findSticker: {
        title: 'Знайди стікер',
        subtitle: 'Завантаж картинку, додай стікери й впиши слово для кожного. Учень читає слово і натискає на стікер.',
        image: 'Зображення',
        placementHint: 'Перетягуй стікери, щоб змінити їх позицію на картинці.',
        addFirst: 'Натисни «Додати стікер», щоб розставити перший.',
        cropHint: 'Тягни прямокутник, щоб обрізати картинку. Кутики змінюють розмір.',
        done: 'Готово',
        cancel: 'Скасувати',
        crop: 'Обрізати',
        resetCrop: 'Скинути обрізку',
        changeImage: 'Змінити',
        deleteImage: 'Видалити',
        addSticker: 'Додати стікер',
        stickers: 'Стікери ({{count}})',
        wordPlaceholder: 'напр. apple',
        size: 'Розмір',
        wordTextStyle: 'Стиль тексту слова',
        wordBgColor: 'Колір фону слова',
        shuffleTitle: 'Перемішувати порядок',
        shuffleOn: 'Порядок пошуку — випадковий',
        shuffleOff: 'Порядок пошуку — як у списку',
      },
      dragLabelText: {
        title: 'Перетягни ярлики у текст',
        subtitle: 'Учень тягне ярлики у пропуски в тексті',
        text: 'Текст',
        addGap: 'Додати пропуск',
        insertGapTooltip: 'Вставити пропуск у позицію курсора',
        textPlaceholder: 'Введіть речення. Натисніть «Додати пропуск», щоб вставити місце для ярлика.',
        gapsHint: 'Пропуски відображаються як',
        inTheText: 'у тексті',
        gaps: 'Пропуски ({{count}})',
        deleteGap: 'Видалити пропуск',
        textColor: 'Колір тексту',
        slotColor: 'Колір пропусків',
        labelColor: 'Колір ярликів',
        labelTextColor: 'Колір тексту ярликів',
        paletteColor: 'Колір панелі відповідей',
      },
      fillGaps: {
        title: 'Заповніть пропуски',
        subtitle: 'Учень друкує відповіді у пропуски в тексті',
        text: 'Текст',
        addGap: 'Додати пропуск',
        insertGapTooltip: 'Вставити пропуск у позицію курсора',
        boldTooltip: 'Виділити жирним (виділіть текст → натисніть B)',
        italicTooltip: 'Виділити курсивом (виділіть текст → натисніть I)',
        textPlaceholder: 'Введіть речення. Поставте курсор у потрібне місце та натисніть «Додати пропуск».',
        formatsHint: 'Пропуски: {{gaps}}. Жирний: {{bold}}. Курсив: {{italic}}',
        gaps: 'Пропуски ({{count}})',
        gapNumber: 'Пропуск #{{index}}',
        deleteGap: 'Видалити пропуск',
        deleteOption: 'Видалити варіант',
        optionPlaceholder: 'Варіант {{index}}',
        addOption: 'Ще варіант',
        multipleAnswersHint: 'Будь-який з варіантів зараховується як правильна відповідь. Регістр і пробіли ігноруються.',
        textColor: 'Колір тексту',
        gapTextColor: 'Колір тексту пропусків',
        gapBorderColor: 'Колір рамки пропусків',
        gapBgColor: 'Фон пропусків',
        validation: 'Додайте хоча б одну правильну відповідь до кожного пропуску',
      },
      dressUp: {
        title: 'Одягалка',
        subtitle: 'Персонаж і гардероб. Учень одягає персонажа — по одній речі з кожної категорії. Найкраще працюють PNG з прозорим фоном.',
        heading: 'Заголовок',
        character: 'Персонаж',
        categories: 'Гардероб',
        layerHint: 'Нижні категорії малюються поверх верхніх (наприклад, куртка поверх футболки).',
        categoryPlaceholder: 'Назва категорії (Hats, Tops…)',
        removeCategory: 'Видалити категорію',
        itemPlaceholder: 'Назва речі (a red hat)',
        place: 'Розмістити на персонажі',
        removeItem: 'Видалити річ',
        addItem: 'Річ',
        bulkUpload: 'Кілька файлів',
        addCategory: 'Додати категорію',
        showNames: 'Показувати назви речей',
        accentColor: 'Акцент',
        panelBgColor: 'Фон гардероба',
        textColor: 'Колір тексту',
      },
      kissMarryAvoid: {
        subtitle: 'Три персонажі. Учень обирає кожному одну з трьох опцій — кожну опцію можна дати лише одному персонажу.',
        heading: 'Заголовок',
        headingPlaceholder: 'Kiss, Marry or Avoid?',
        characters: 'Персонажі',
        characterNumber: 'Персонаж {{index}}',
        namePlaceholder: 'Імʼя (необовʼязково, якщо є фото)',
        upload: 'Завантажити',
        photoLibrary: 'Фото',
        options: 'Опції',
        cardBgColor: 'Фон карток',
        textColor: 'Колір тексту',
      },
      boardGame: {
        title: 'Ходилка',
        subtitle: 'Гравці по черзі кидають кубик і ходять по клітинках. На кожній клітинці — завдання. Клітинка може перекинути вперед або назад.',
        heading: 'Заголовок',
        players: 'Гравці',
        addPlayer: 'Додати гравця',
        startLabel: 'Старт',
        finishLabel: 'Фініш',
        cells: 'Клітинки-завдання ({{count}})',
        cellPlaceholder: 'Завдання (напр. Name 3 fruits)',
        jump: 'Перехід',
        noJump: 'немає',
        image: 'Картинка',
        addCell: 'Додати клітинку',
        columns: 'Клітинок у ряду: {{count}}',
        boardColor: 'Фон поля',
        cellColor: 'Фон клітинок',
        accentColor: 'Старт / фініш',
        textColor: 'Колір тексту',
      },
      spotDifference: {
        title: 'Знайди відмінності',
        subtitle: 'Дві схожі картинки однакового розміру. Позначте відмінності кліком — учень шукає їх на будь-якій з картинок.',
        heading: 'Заголовок',
        imageA: 'Картинка 1',
        imageB: 'Картинка 2',
        markHint: 'Клікніть на відмінність ({{count}})',
        size: 'Розмір',
        layout: 'Розташування',
        horizontal: 'Поруч',
        vertical: 'Одна під одною',
        markerColor: 'Колір позначки',
        textColor: 'Колір тексту',
      },
      mindMap: {
        subtitle: 'Тема в центрі, навколо — гілки та ідеї. На уроці учень додає свої гілки та ідеї кнопкою «+».',
        center: 'Центральна тема',
        allowAdd: 'Учень може додавати гілки та ідеї',
        branches: 'Гілки ({{count}})',
        branchesHint: 'Можна залишити порожнім — тоді учень будує карту з нуля.',
        branchPlaceholder: 'Гілка (напр. Transport)',
        leafPlaceholder: 'Ідея (напр. by plane)',
        addLeaf: 'Ідея',
        addBranch: 'Додати гілку',
        centerColor: 'Фон центру',
        centerTextColor: 'Текст центру',
        nodeBgColor: 'Фон ідей',
        textColor: 'Колір тексту',
      },
      dialogue: {
        title: 'Діалог-симулятор',
        subtitle: 'Персонаж пише репліку — учень обирає відповідь. Неправильна відповідь не просуває діалог. Для розгалуження вкажіть, куди веде кожна відповідь.',
        characterName: 'Імʼя персонажа',
        subtitleField: 'Підпис',
        avatar: 'Аватар',
        steps: 'Кроки діалогу ({{count}})',
        stepNumber: 'Крок {{index}}',
        botTextPlaceholder: 'Що каже персонаж',
        markWrong: 'Позначити як неправильну',
        markCorrect: 'Позначити як правильну',
        optionPlaceholder: 'Відповідь учня',
        replyPlaceholderCorrect: 'Реакція персонажа (необовʼязково)',
        replyPlaceholderWrong: 'Реакція на помилку (напр. Sorry, what?)',
        goesTo: 'Далі:',
        nextInList: 'наступний крок',
        endDialogue: 'кінець діалогу',
        addOption: 'Варіант відповіді',
        addStep: 'Додати крок',
        autoSpeak: 'Озвучувати репліки персонажа автоматично',
        voice: 'Голос',
        botBubbleColor: 'Репліки персонажа',
        botTextColor: 'Текст персонажа',
        myBubbleColor: 'Репліки учня',
        myTextColor: 'Текст учня',
      },
      pictionary: {
        subtitle: 'Один малює загадане слово, інший вгадує вголос. Слово бачить лише той, хто малює.',
        mode: 'Режим',
        modeDuo: 'Учень ↔ вчитель',
        modeTeams: 'Команди',
        modeTeamsHint: 'Вчитель — ведучий: бачить слово і зараховує бали. Художник команди підглядає слово кнопкою «Затисни».',
        modeDuoHint: 'Учень і вчитель малюють по черзі. Бал отримує той, хто малював, якщо слово вгадали.',
        teams: 'Команди',
        addTeam: 'Додати команду',
        firstDrawer: 'Першим малює',
        words: 'Слова — по одному в рядку ({{count}})',
        roundSeconds: 'Час на раунд: {{count}} с',
        canvasColor: 'Фон полотна',
        accentColor: 'Акцент',
      },
      personalityQuiz: {
        title: 'Тест-характеристика',
        subtitle: 'Учень відповідає на питання по одному. Кожна відповідь додає бал одному з результатів — у кінці показується результат з найбільшою кількістю балів.',
        quizTitle: 'Заголовок',
        quizTitlePlaceholder: 'Which princess are you?',
        results: 'Результати ({{count}})',
        resultNumber: 'Результат {{letter}}',
        deleteResult: 'Видалити результат',
        resultTitlePlaceholder: 'Заголовок (напр. You are Cinderella!)',
        resultDescriptionPlaceholder: 'Текст результату',
        resultsHint: 'Що побачить учень у кінці залежно від того, яких відповідей у нього найбільше.',
        resultIf: 'Якщо найбільше «{{letter}}» →',
        previewResult: 'Показати цей результат на слайді',
        addResult: 'Додати результат',
        questions: 'Питання ({{count}})',
        questionNumber: 'Питання #{{index}}',
        deleteQuestion: 'Видалити питання',
        questionPlaceholder: 'Питання',
        optionPlaceholder: 'Варіант відповіді',
        deleteOption: 'Видалити варіант',
        addOption: 'Додати варіант',
        addQuestion: 'Додати питання',
        givesPointTo: '+1 бал результату',
        noResult: '— результат —',
        unassignedWarning: 'Деякі відповіді не привʼязані до результату — вони не дають балів.',
        emptyHint: 'Додайте результати та питання у налаштуваннях праворуч',
        accentColor: 'Акцентний колір',
        optionBgColor: 'Фон варіантів',
        textColor: 'Колір тексту',
      },
      memory: {
        title: 'Memory',
        subtitle: 'Учень перевертає картки й шукає пару: слово ↔ картинка. Можна лишити тільки слова або тільки картинки.',
        pairs: 'Пари ({{count}})',
        pairNumber: 'Пара #{{index}}',
        deletePair: 'Видалити пару',
        addPair: 'Додати пару',
        textPlaceholder: 'Слово',
        addAtLeastTwoPairs: 'Додайте принаймні дві пари',
        addPairsHint: 'Додайте пари у налаштуваннях праворуч',
        columns: 'Колонок',
        columnsAuto: 'авто',
        columnsHint: '0 = авто. Карток на дошці: {{count}}.',
        cardBackColor: 'Колір сорочки',
        cardFrontColor: 'Колір лиця',
        matchedBorderColor: 'Рамка знайдених',
        textColor: 'Колір тексту',
      },
      matchLines: {
        title: 'Поєднай лініями',
        subtitle: 'Учень зʼєднує крапки в пари. Зліва — у початковому порядку, справа — перемішано.',
        pairs: 'Пари ({{count}})',
        addPair: 'Додати пару',
        pairNumber: 'Пара #{{index}}',
        deletePair: 'Видалити пару',
        leftPlaceholder: 'Ліворуч',
        rightPlaceholder: 'Праворуч',
        topPlaceholder: 'Зверху',
        bottomPlaceholder: 'Знизу',
        layout: 'Розташування',
        layoutHorizontal: 'Ліво ↔ право',
        layoutVertical: 'Верх ↕ низ',
        uploadImageTooltip: 'Натисніть або перетягніть файл сюди',
        uploadAudioTooltip: 'Натисніть, щоб завантажити аудіо',
        uploading: 'Завантаження...',
        dropFile: 'Відпустіть файл',
        picture: 'Картинка',
        sticker: 'Стікер',
        stickerTooltip: 'Обрати зі стікерів',
        audio: 'Аудіо',
        deleteAudio: 'Видалити аудіо',
        invalidAudio: 'Дозволені формати: MP3, WAV, OGG, M4A',
        fileTooLarge50: 'Максимальний розмір: 50MB',
        uploadAudioError: 'Не вдалось завантажити аудіо',
        addAtLeastTwoPairs: 'Додайте принаймні дві пари',
        allowRetryCheckbox: 'Дозволити повторну спробу',
        columnWidths: 'Ширина стовпчиків ({{left}}% / {{right}}%)',
        leftLabel: 'Ліворуч',
        rightLabel: 'Праворуч',
        reset5050: 'Скинути 50% / 50%',
        lineColor: 'Колір ліній',
        dotColor: 'Колір крапок',
        leftBg: 'Фон лівих',
        rightBg: 'Фон правих',
        leftText: 'Колір тексту лівих',
        rightText: 'Колір тексту правих',
      },
      labelImage: {
        title: 'Лінії на зображенні',
        subtitle: 'Учень зʼєднує слова-мітки з крапками на зображенні.',
        image: 'Зображення',
        uploadImage: 'Завантажити зображення',
        replaceImage: 'Замінити',
        dropFile: 'Відпустіть файл',
        dropHint: 'або перетягніть файл сюди',
        sticker: 'Стікер',
        pickSticker: 'Обрати зі стікерів',
        addDot: 'Додати крапку',
        clickOnImage: 'Клікніть на зображення…',
        dragHint: 'Перетягніть крапки, щоб змінити позицію.',
        items: 'Мітки',
        labelNumber: 'Мітка #{{index}}',
        deleteLabel: 'Видалити',
        labelPlaceholder: 'Слово (напр. Deltoid)',
        sideLeft: 'Ліворуч',
        sideRight: 'Праворуч',
        color: 'Колір',
        addLabel: 'Додати мітку',
        addFirstHint: 'Додайте мітку — вона зʼявиться у центрі зображення. Потім перетягніть крапку.',
        allowRetryCheckbox: 'Дозволити повторну спробу',
        dotSize: 'Розмір крапок',
        lineColor: 'Колір ліній (fallback)',
        dotFill: 'Заливка крапки',
        dotBorder: 'Обвідка крапки',
      },
      oddOneOut: {
        title: 'Зайве слово',
        subtitle: 'Учень обирає зайвий елемент у кожному рядку. 1 бал за правильний рядок.',
        rowNumber: 'Рядок {{index}}',
        onePoint: '· 1 бал',
        deleteRow: 'Видалити рядок',
        itemCount: 'Кількість елементів',
        itemsLabel: 'Елементи (натисніть колечко зліва, щоб позначити зайвий)',
        oddMarker: 'Зайвий',
        markAsOdd: 'Позначити як зайвий',
        text: 'Текст',
        audio: 'Аудіо',
        itemPlaceholder: 'Слово {{index}}',
        deleteAudio: 'Видалити аудіо',
        uploading: 'Завантаження...',
        uploadAudio: 'Завантажити аудіо',
        explanation: 'Пояснення',
        explanationHelp: '(показується після відповіді)',
        explanationPlaceholder: 'Наприклад: «Стілець» — це не фрукт',
        addRow: 'Додати рядок',
        invalidAudio: 'Дозволені формати: MP3, WAV, OGG, M4A',
        fileTooLarge50: 'Максимальний розмір: 50MB',
        uploadAudioError: 'Не вдалось завантажити аудіо',
        alignment: 'Вирівнювання',
        alignLeft: 'По лівому краю',
        alignCenter: 'По центру',
        alignRight: 'По правому краю',
      },
      pronounce: {
        targetLabel: 'Слово або фраза для вимови',
        targetPlaceholder: 'Напр.: apple',
        listen: 'Прослухати',
        recognitionLanguage: 'Мова розпізнавання',
        starsForAccuracy: 'Зірочки за точність вимови',
        accuracyHeader: 'Точність (0.0–1.0) ≥',
        starsHeader: 'Зірочок',
        accuracyHint: 'Точність = наскільки розпізнане слово збігається з еталоном (1.0 — ідеально). Web Speech API розпізнає слова, але не оцінює наголос/інтонацію.',
        allowRetry: 'Дозволити повторну спробу',
        showTargetToStudent: 'Показувати учню написання слова',
        appearance: 'Оформлення',
        wordFontSize: 'Розмір тексту слова',
        wordFont: 'Шрифт',
        wordColor: 'Колір тексту слова',
        micButtonColor: 'Колір кнопки мікрофона',
        bottomBarColor: 'Колір нижньої панелі',
        langEnUS: 'Англійська (US)',
        langEnGB: 'Англійська (UK)',
        langUkUA: 'Українська',
        langRuRU: 'Російська',
        langPlPL: 'Польська',
        langDeDE: 'Німецька',
        langFrFR: 'Французька',
        langEsES: 'Іспанська',
        langItIT: 'Італійська',
      },
      sorting: {
        title: 'Сортування',
        subtitle: 'Учень перетягує елементи у правильні категорії. 1 бал за правильно розсортований елемент.',
        layout: 'Вигляд',
        baskets: 'Корзинки',
        table: 'Таблиця',
        paletteSide: 'Розташування пулу елементів',
        top: 'Зверху',
        bottom: 'Знизу',
        left: 'Зліва',
        right: 'Справа',
        categoriesLabel: 'Категорії',
        categoryDefault: 'Категорія {{index}}',
        categoryColor: 'Колір категорії',
        categoryPlaceholder: 'Назва категорії',
        deleteCategory: 'Видалити категорію',
        addCategory: 'Додати категорію',
        itemsLabel: 'Елементи для сортування',
        addCategoryFirst: 'Спочатку додайте хоча б одну категорію.',
        itemPlaceholder: 'Елемент {{index}}',
        correctCategory: 'Правильна категорія',
        noName: 'Без назви',
        categoryChoice: '— Категорія —',
        addItem: 'Додати елемент',
        primaryCategoryColor: 'Основний колір категорій',
        itemBg: 'Фон елементів',
      },
      tableFill: {
        title: 'Заповнення таблиці',
        subtitle: 'Клітинки з олівцем учень заповнює сам, клітинки з оком видно одразу. 1 бал за кожну правильно заповнену клітинку.',
        cells: 'Клітинки',
        legendGiven: 'Видно учню',
        legendAnswer: 'Учень вводить',
        alternativesHint: 'Текст клітинки з олівцем — правильна відповідь. Кілька варіантів розділяйте символом |. Порожні клітинки не перевіряються.',
        inputBg: 'Фон клітинок для відповіді',
        validation: 'Позначте олівцем хоча б одну клітинку з відповіддю',
      },
      table: {
        title: 'Таблиця',
        subtitle: 'Клацніть на клітинку, щоб ввести текст',
        rows: 'Рядки ({{count}})',
        columns: 'Колонки ({{count}})',
        firstRowHeader: 'Перший рядок — заголовок',
        borderWidth: 'Товщина рамки ({{width}}px)',
        borderColor: 'Колір рамки',
        cellBg: 'Фон клітинок',
        headerBg: 'Фон заголовка',
        headerText: 'Текст заголовка',
      },
      puzzle: {
        title: 'Пазл',
        subtitle: 'Завантажте картинку і виберіть кількість пазлів. Розставте пазли на слайді — учень збере їх у рамку.',
        image: 'Зображення',
        uploadImage: 'Завантажити картинку',
        changeImage: 'Змінити',
        deleteImage: 'Видалити',
        gridSize: 'Розмір сітки',
        rows: 'Рядки',
        cols: 'Колонки',
        totalPieces: 'Пазлів: {{count}}',
        regenerate: 'Перегенерувати форму та розсипати',
        frameColor: 'Колір рамки-цілі',
        tip: 'Рамку і пазли можна перетягувати прямо на слайді. Розтягуйте рамку за правий нижній кут — форма зберігається за пропорціями зображення.',
      },
      abcd: {
        title: 'ABCD',
        subtitle: 'Питання з 2–4 варіантами відповіді. Учень обводить правильний, вчитель натискає «Перевірити»',
        instructionPlaceholder: 'Напр. Choose the correct answer',
        addQuestion: 'Додати питання',
        importButton: 'Імпорт текстом',
        importHint: 'Питання — окремим рядком, під ним варіанти a) b) c) d). Правильний позначте зірочкою * у кінці. Між питаннями — порожній рядок.',
        loadCurrent: 'Завантажити поточні питання як текст',
        importPreview: 'Розпізнано питань: {{count}}',
        importCancel: 'Скасувати',
        importReplace: 'Замінити всі',
        importAppend: 'Додати',
        importSuccess: 'Додано питань: {{count}}',
        questions: 'Питання',
        questionPlaceholder: 'Питання {{index}}',
        deleteQuestion: 'Видалити питання',
        optionPlaceholder: 'Варіант {{letter}}',
        addOption: 'Додати варіант',
        deleteOption: 'Видалити варіант',
        markCorrect: 'Позначити як правильний',
        correctHint: 'Натисніть на літеру, щоб позначити правильну відповідь.',
        layout: 'Розташування варіантів',
        layoutRow: 'В рядок',
        layoutColumn: 'Стовпчиком',
        circleColor: 'Колір обведення',
        validation: 'Додайте хоча б одне питання',
        emptyOptions: 'Порожніх варіантів: {{count}}',
      },
      trueFalse: {
        title: 'True / False',
        subtitle: 'Учні пишуть T (true), F (false){{extra}} у квадратиках',
        subtitleExtra: ', N (no information)',
        instructionPlaceholder: 'Напр. Прочитайте твердження і поставте T, F або N',
        variantN: 'Варіант "N" (no information)',
        variantNOnDesc: 'Учні можуть обрати T, F або N',
        variantNOffDesc: 'Лише T або F',
        lettersLabel: 'Літери відповідей',
        lettersDuplicate: 'Літери мають бути різними',
        roleT: 'True',
        roleF: 'False',
        roleN: 'No info',
        statements: 'Твердження',
        statementPlaceholder: 'Твердження {{index}}',
        addStatement: 'Додати твердження',
        deleteStatement: 'Видалити',
        audioLabel: 'Аудіо (необов\'язково)',
        addAudio: 'Додати аудіо',
        deleteAudio: 'Видалити аудіо',
        uploadingAudio: 'Завантаження…',
        invalidAudio: 'Оберіть аудіо-файл',
        fileTooLarge: 'Максимальний розмір файлу — 50 МБ',
        uploadAudioError: 'Не вдалося завантажити аудіо',
        boxBg: 'Фон квадратиків',
        boxBorderColor: 'Колір рамки квадратиків',
        letterColor: 'Колір відповідей (T/F)',
        validation: 'Додайте хоча б одне твердження',
      },
      typeAnswer: {
        title: 'Введіть відповідь',
        subtitle: 'Учень вводить відповідь у текстове поле',
        question: 'Питання',
        questionPlaceholder: 'Введіть питання...',
        correctAnswers: 'Правильні відповіді',
        answerPlaceholder: 'Варіант {{index}}',
        addOption: 'Додати варіант',
        deleteOption: 'Видалити',
        answersHint: 'Будь-який варіант буде зарахований як правильна відповідь. Регістр і пробіли по краях ігноруються.',
        placeholderLabel: 'Підказка в полі (placeholder)',
        placeholderPlaceholder: 'Введіть відповідь...',
        inputBg: 'Фон поля вводу',
        inputTextColor: 'Колір тексту вводу',
        inputBorderColor: 'Колір рамки поля вводу',
        validation: 'Додайте хоча б одну правильну відповідь',
      },
      missingLetters: {
        title: 'Пропущені літери',
        subtitle: 'Напишіть слово і натисніть на літери, які треба сховати. Учень впише їх у порожні клітинки.',
        word: 'Слово',
        wordPlaceholder: 'Напр.: apple',
        toggleHint: 'Натисни на літеру, щоб приховати або показати її',
        autoPick: 'Авто',
        clear: 'Показати всі',
        hiddenCount: 'Приховано: {{count}}',
        showLetter: 'Показати літеру',
        hideLetter: 'Приховати літеру',
        hint: 'Підказка',
        hintOptional: '(необовʼязково)',
        hintPlaceholder: 'Напр.: fruit, з двома «p»',
        tileBg: 'Фон видимих літер',
        inputBg: 'Фон порожніх клітинок',
        inputBorderColor: 'Колір рамки порожніх клітинок',
        validationWord: 'Введіть слово',
        validationHidden: 'Приховайте хоча б одну літеру',
      },
      rank: {
        title: 'Ранжування',
        subtitle: 'Учень розставляє елементи від першого до останнього. 1 бал за правильну позицію.',
        layout: 'Вигляд',
        vertical: 'Вертикально',
        horizontal: 'Горизонтально (сходинки)',
        itemsLabel: 'Елементи у правильному порядку',
        orderHint: 'Позиція №1 — це той елемент, який учень має поставити першим.',
        itemPlaceholder: 'Елемент {{index}}',
        addItem: 'Додати елемент',
        moveUp: 'Пересунути вгору',
        moveDown: 'Пересунути вниз',
        endLabels: 'Підписи країв (необовʼязково)',
        topLabelPlaceholder: 'Підпис зверху (напр.: "Найбільше")',
        bottomLabelPlaceholder: 'Підпис знизу (напр.: "Найменше")',
        slotColor: 'Колір слотів',
        itemBg: 'Фон елементів',
        showNumbers: 'Нумерація позицій',
        showNumbersOn: 'Показувати 1, 2, 3…',
        showNumbersOff: 'Без нумерації',
      },
      unjumble: {
        title: 'Скласти речення',
        subtitle: 'Учень перетягує слова, щоб скласти речення у правильному порядку.',
        bonusPerSentence: ' 1 бал за кожне правильне речення.',
        correctSentences: 'Правильні речення',
        sentenceNumber: 'Речення {{index}}',
        wordSingular: 'слово',
        wordPlural: 'слів',
        deleteSentence: 'Видалити речення',
        sentencePlaceholder: 'The cat sat on the mat.',
        addSentence: 'Додати речення',
        wordsShuffleHint: 'Слова автоматично перемішаються. Учень отримує 1 бал за кожне правильно складене речення.',
        hint: 'Підказка',
        hintOptional: '(необовʼязково)',
        hintPlaceholder: 'Напр.: past simple, question form',
        tileBg: 'Фон слів',
        tileBorderColor: 'Колір рамки слів',
        alignment: 'Вирівнювання',
        alignLeft: 'По лівому краю',
        alignCenter: 'По центру',
        alignRight: 'По правому краю',
        showNumbers: 'Нумерація речень',
        showNumbersOn: 'Речення нумеруються (1., 2., 3. …)',
        showNumbersOff: 'Без нумерації',
        numberColor: 'Колір нумерації',
      },
      orderSentences: {
        title: 'Порядок речень',
        subtitle: 'Учень перетягує речення у стовпчику, щоб скласти їх у правильному порядку. 1 бал за кожну правильну позицію.',
        correctOrder: 'Речення у правильному порядку',
        positionLabel: 'Позиція {{index}}',
        moveUp: 'Пересунути вгору',
        moveDown: 'Пересунути вниз',
        deleteSentence: 'Видалити речення',
        sentencePlaceholder: 'Напр.: I wake up at seven.',
        addSentence: 'Додати речення',
        shuffleHint: 'Речення автоматично перемішаються. Учень має перетягнути їх у правильний порядок.',
        hint: 'Підказка',
        hintOptional: '(необовʼязково)',
        hintPlaceholder: 'Напр.: типовий розпорядок дня',
        tileBg: 'Фон речень',
        tileBorderColor: 'Колір рамки',
        alignment: 'Вирівнювання',
        alignLeft: 'По лівому краю',
        alignCenter: 'По центру',
        alignRight: 'По правому краю',
        showNumbers: 'Нумерація позицій',
        showNumbersOn: 'Позиції нумеруються (1., 2., 3. …)',
        showNumbersOff: 'Без нумерації',
        numberColor: 'Колір нумерації',
      },
      wordPool: {
        title: 'Boggle',
        subtitle: 'Учень складає слова з літер у пулі. Сусідство не потрібне — будь-яка літера, кожна не більше одного разу за слово.',
        gameMode: 'Режим гри',
        modeTime: 'На час',
        modeTargets: 'Знайти цілі',
        modeTimeHint: 'Учень шукає якомога більше англійських слів за відведений час (перевірка через словник).',
        modeTargetsHint: 'Учень має знайти всі задані слова з пулу літер.',
        letterCount: 'Кількість літер',
        layout: 'Розташування літер',
        layoutCloud: 'Хмара',
        layoutRow: 'Рядок',
        layoutSquare: 'Квадрат',
        layoutCircle: 'Коло',
        letters: 'Літери ({{count}})',
        random: 'Випадкові',
        addLetter: '+ літера',
        addLettersHint: 'Додайте літери',
        targetWords: 'Слова для пошуку',
        wordInputPlaceholder: 'Введіть слово...',
        wordFindable: 'Можна скласти з пулу',
        wordNotFindable: 'Не складається з пулу — не вистачає літер',
        someUnfindable: 'Деяким словам не вистачає літер у пулі. Додайте літери або заміни слова.',
        timeLimit: 'Час на гру',
        timeSec: 'сек',
        timeMin: 'хв',
        timeHintMin: 'Від 1 до 60 хвилин. Таймер стартує з першим кліком учня.',
        timeHintSec: 'Від 10 до 3600 секунд. Таймер стартує з першим кліком учня.',
        minWordsToPass: 'Мінімум слів для «зараховано»',
        minWordLength: 'Мінімальна довжина слова',
        addAtLeastOneWord: 'Додайте хоча б одне слово для пошуку',
      },
    },
    exerciseConfig: {
      singleChoiceTitle: 'Один правильний',
      multipleChoiceTitle: 'Кілька правильних',
      singleChoiceSubtitle: 'Учень може обрати лише один варіант',
      multipleChoiceSubtitle: 'Учень може обрати кілька варіантів',
      question: 'Питання',
      questionPlaceholder: 'Введіть питання...',
      answerOptions: 'Варіанти відповіді ({{count}}/6)',
      addOption: 'Додати',
      correctAnswer: 'Правильна відповідь',
      markAsCorrect: 'Позначити як правильну',
      deleteOption: 'Видалити варіант',
      pickAtLeastOneCorrect: 'Оберіть хоча б одну правильну відповідь',
      retryTitle: 'Повторна спроба',
      retryOn: 'Учень може спробувати ще раз',
      retryOff: 'Лише одна спроба',
      questionTextColor: 'Колір тексту питання',
      questionBgColor: 'Фон питання',
      optionsTextColor: 'Колір тексту варіантів',
      optionsBgColor: 'Фон варіантів',
    },
    richText: {
      boldTitle: 'Жирний (Ctrl+B)',
      italicTitle: 'Курсив (Ctrl+I)',
      underlineTitle: 'Підкреслений (Ctrl+U)',
      insertTable: 'Вставити таблицю',
      addRow: 'Додати рядок',
      deleteRow: 'Видалити рядок',
      addColumn: 'Додати колонку',
      deleteColumn: 'Видалити колонку',
      insertImage: 'Вставити зображення',
      selectAndBoldHint: 'Виділіть текст та натисніть B для жирного шрифту',
      selectAndFormatHint: 'Виділіть текст та застосуйте форматування',
      imageTooLarge: 'Зображення занадто велике. Максимальний розмір: 5MB',
      defaultPlaceholder: 'Введіть текст...',
    },
    lessonGames: {
      pageTitle: 'Ігри для повторення',
      teacherOwnLessons: 'Мої уроки',
      back: 'Назад',
      addGame: 'Додати гру',
      bindFromLibrary: 'Додати з бібліотеки',
      pickFromLibrary: 'Обери гру з бібліотеки',
      libraryEmpty: 'Бібліотека порожня. Створи ігри у вкладці «Ігри на повторення».',
      createInTabHint: 'Створюй нові ігри у вкладці «Ігри на повторення» — тут вони лише прив’язуються до уроку.',
      noBoundGames: 'До цього уроку ще не прив’язано жодної гри',
      noBoundGamesHint: 'Натисни «Додати з бібліотеки» щоб прив’язати гру.',
      bindAction: 'Прив’язати',
      unbind: 'Відв’язати',
      unbindTitle: 'Відв’язати гру?',
      unbindConfirm: 'Відв’язати гру «{{name}}» від цього уроку? Сама гра залишиться в бібліотеці.',
      noGames: 'Ще немає ігор',
      noGamesHint: 'Натисни "Додати гру" щоб створити першу',
      pickGameType: 'Обери тип гри',
      preview: 'Переглянути гру',
      edit: 'Редагувати',
      close: 'Закрити',
      titleLabelOptional: 'Назва (необов\'язково)',
      titlePlaceholder: 'напр. {{label}} — урок 3',
      cancel: 'Скасувати',
      save: 'Зберегти',
      saving: 'Збереження…',
      deleteTitle: 'Видалити гру?',
      deleteConfirm: 'Видалити гру "{{name}}"? Цю дію не можна скасувати.',
      createFailedTitle: 'Не вдалось створити гру',
      createFailedMessage: 'Перевір що бекенд запущений і спробуй ще раз.',
      gameTypes: {
        memoryDesc: 'Знайди пару: слово ↔ картинка',
        labelledDiagramDesc: 'Перетягни підписи на правильні точки картинки',
        pairOrNoPairDesc: 'Вирішує чи дві картки належать одна одній',
        listenTypeDesc: 'Прослухай аудіо й набери що почув',
        listenPickImageDesc: 'Прослухай слово й обери правильну картинку',
        sortingDesc: 'Перетягни слова в правильні коробки/кошики/смітники',
        dictationDesc: 'Кен озвучує фразу — учень записує почуте',
        findObjectDesc: 'Знайди предмет на картинці за словом',
        pickPronunciationDesc: 'Обери іконку, яка вимовляє написане слово',
        listenPickWordDesc: 'Прослухай слово й обери яке з двох ти чуєш',
        sunscreenDesc: 'Учень мастить крем на частини тіла Кена (для тем body / beach)',
        thisOrThatDesc: 'Питання посередині, два варіанти внизу — учень обирає правильний',
        spellPictureDesc: 'Картинка + риски: учень вводить слово по буквах',
      },
    },
    programEditor: {
      title: 'Редактор програми',
      back: 'Назад',
      save: 'Зберегти',
      saving: 'Збереження...',
      cancel: 'Скасувати',
      add: 'Додати',
      titleLabel: 'Назва',
      descriptionLabel: 'Опис',
      levelLabel: 'Рівень',
      ageCategoryLabel: 'Вікова категорія',
      lessonsHeading: 'Уроки',
      modulesHeading: 'Модулі',
      addModule: 'Додати модуль',
      addLesson: 'Додати урок',
      newModuleTitle: 'Нова назва модуля',
      newLessonTitle: 'Назва уроку',
      newLessonDescription: 'Опис уроку',
      presentation: 'Презентація',
      homework: 'Домашнє завдання',
      specialLessons: 'Спеціальні уроки',
      repetitionLessons: 'Уроки повторення',
      moduleTest: 'Модульний тест',
      matchingMetadata: 'Метадані підбору',
      frequency: 'Частота',
      englishType: 'Тип англійської',
      ageMin: 'Мін. вік',
      ageMax: 'Макс. вік',
      gender: 'Стать',
      topics: 'Теми',
      learningGoal: 'Мета навчання',
      overrideWeights: 'Перевизначити ваги',
      weightsLabels: {
        level: 'Рівень',
        age: 'Вік',
        topics: 'Теми',
        learningGoal: 'Мета',
        frequency: 'Частота',
        englishType: 'Тип англійської',
      },
      errorTitle: 'Помилка',
      successTitle: 'Успіх',
      alerts: {
        stillLoading: 'Програма ще завантажується. Зачекайте кілька секунд і спробуйте знову.',
        enterProgramTitle: 'Будь ласка, введіть назву програми',
        pickLevel: 'Будь ласка, оберіть рівень',
        ageFromGreaterThanTo: 'Вік "від" не може бути більше за "до"',
        weightsSumMust100: 'Сума ваг повинна = 100 (зараз {{sum}})',
        atLeastOneModule: 'Створіть хоча б один модуль',
        allLessonsMustBelongModule: 'Усі уроки повинні належати модулю',
        saveFailed: 'Не вдалося зберегти програму',
        pickModuleFirst: 'Спочатку оберіть модуль',
        enterLessonTitle: 'Будь ласка, введіть назву уроку',
        enterModuleTitle: 'Введіть назву модуля',
        moduleTitleNotEmpty: 'Назва модуля не може бути порожньою',
        altModuleLimit: 'Не більше 9 альтернатив на модуль',
        altLessonCountMismatch: 'Альтернативний модуль "{{title}}" має {{alt}} уроків, а основний — {{primary}}. Кількість повинна збігатися.',
        enterCategoryName: 'Введіть назву категорії',
        categoryCreated: 'Категорію створено',
        createCategoryFailed: 'Не вдалося створити категорію',
        pickPresentationAndCategory: 'Оберіть презентацію та категорію',
        specialLessonAdded: 'Спеціальний урок додано',
        addSpecialLessonFailed: 'Не вдалося додати спеціальний урок',
        pickPresentation: 'Оберіть презентацію',
        repetitionLessonAdded: 'Урок повторення додано',
        addRepetitionLessonFailed: 'Не вдалося додати урок повторення',
      },
      confirms: {
        deleteLessonTitle: 'Видалити урок?',
        deleteLessonMessage: 'Видалити урок з програми?',
        deleteModuleTitle: 'Видалити модуль?',
        deleteModuleWithLessons: 'Видалити модуль і {{count}} {{noun}} в ньому?',
        deleteModuleAlone: 'Видалити цей модуль?',
        deletePrimaryWithAlternatives: 'Видалити цей модуль разом з {{count}} альтернативними модулями ({{lessons}} уроків загалом)?',
        deleteSpecialLessonTitle: 'Видалити спеціальний урок?',
        deleteSpecialLessonMessage: 'Видалити "{{title}}" з програми?',
        deleteRepetitionLessonTitle: 'Видалити урок повторення?',
        deleteRepetitionLessonMessage: 'Видалити "{{title}}" з програми?',
      },
      altModule: {
        addBtn: '+ Альтернативний модуль',
        badge: 'Альтернатива',
        badgeTooltip: 'Учитель обере один з альтернативних модулів для кожного учня',
        suffix: 'Альтернатива',
        descriptionLabel: 'Опис (побачить вчитель при виборі)',
        descriptionPlaceholder: 'Наприклад: підходить для активних дітей, які люблять ігри',
        groupTitlePlaceholder: 'Модуль 1',
        groupTitleTooltip: 'Загальна назва модуля (спільна для всіх альтернатив)',
      },
      lessonRow: {
        titleLabel: 'Назва уроку *',
        descriptionLabel: 'Опис уроку',
        presentationLabel: 'Презентація',
        pickPresentation: 'Оберіть презентацію...',
        searchPresentation: 'Пошук презентації...',
        homeworkLabel: 'Домашнє завдання',
        pickHomework: 'Оберіть домашнє завдання...',
        searchHomework: 'Пошук домашнього завдання...',
        noResults: 'Нічого не знайдено',
        homeworkStats: '({{exercises}} вправ, {{points}} балів)',
        save: 'Зберегти',
        cancel: 'Скасувати',
        presentationPrefix: 'Презентація: {{title}}',
        presentationNone: 'Не вибрано',
        homeworkPrefix: 'ДЗ: {{title}}',
        homeworkNoneLine: 'Домашнє завдання: Не вибрано',
        replayGamesTooltip: 'Ігри для повторення',
        editTooltip: 'Редагувати урок',
        deleteTooltip: 'Видалити урок',
        repetitionGamesLabel: 'Ігри на повторення',
        repetitionGamesPick: '+ Додати гру на повторення...',
        repetitionGamesRemove: 'Видалити гру',
        repetitionGamesSaveHint: 'Спочатку збережіть програму, щоб додати ігри на повторення до цього уроку.',
      },
      newLesson: {
        heading: 'Новий урок',
        titleLabel: 'Назва уроку *',
        titlePlaceholder: 'Введіть назву уроку',
        descriptionLabel: 'Опис уроку',
        descriptionPlaceholder: 'Опис уроку...',
        presentationLabel: 'Презентація',
        pickPresentation: 'Оберіть презентацію...',
        homeworkLabel: 'Домашнє завдання',
        pickHomework: 'Оберіть домашнє завдання...',
        createHomeworkHint: 'Створюйте нові завдання у вкладці "Домашні завдання"',
        add: 'Додати',
        cancel: 'Скасувати',
      },
      header: {
        newProgram: 'Нова програма',
        editingProgram: 'Редагування програми',
        newProgramSubtitle: 'Створіть нову навчальну програму',
        editingProgramSubtitle: 'Редагування: {{title}}',
        cancel: 'Скасувати',
        saveTooltip: 'Програма ще завантажується...',
        save: 'Зберегти',
        loadingWarning: 'Завантаження програми... Не натискайте «Зберегти», поки дані не з\'являться, інакше можна випадково перезаписати програму порожнім вмістом.',
      },
      details: {
        heading: 'Деталі програми',
        nameLabel: 'Назва програми *',
        namePlaceholder: 'Введіть назву програми',
        descriptionLabel: 'Опис програми',
        descriptionPlaceholder: 'Додайте опис програми...',
        levelLabel: 'Рівень *',
        pickLevel: 'Оберіть рівень...',
        ageCategoryLabel: 'Вікова категорія',
        pickAgeCategory: 'Оберіть категорію...',
        ageChild: 'Дитина',
        ageTeen: 'Підліток',
        ageAdult: 'Дорослий',
        nextProgramLabel: 'Наступна програма',
        nextProgramNone: 'Не задано',
        nextProgramHint: 'Коли учень пройде цю програму, у той самий час у розкладі автоматично почнеться наступна.',
      },
      matching: {
        heading: 'Параметри матчингу',
        description: 'Використовуються для автоматичного підбору програми студенту при записі на індивідуальні заняття.',
        frequencyLabel: 'Частота (раз/тиждень)',
        frequencyNotSet: 'Не задано',
        frequency2: '2 рази',
        frequency3: '3 рази',
        englishTypeLabel: 'Тип англійської',
        englishTypeNotSet: 'Не задано',
        ageFromLabel: 'Вік від',
        ageFromPlaceholder: 'напр. 18',
        ageToLabel: 'Вік до',
        ageToPlaceholder: 'напр. 25',
        topicsLabel: 'Теми',
        topicInputPlaceholder: 'Введіть тему і натисніть Enter',
        learningGoalLabel: 'Мета вивчення мови',
        advancedHeading: 'Розширене: ваги для цієї програми',
        advancedHint: '(за замовчуванням використовуються глобальні)',
        weightsSumHint: 'Сума ваг повинна дорівнювати 100%.',
        weightsSum: 'Сума: {{sum}}%',
      },
      lessonsSection: {
        heading: 'Уроки програми',
        addModule: 'Додати модуль',
        newModuleHeading: 'Новий модуль',
        newModulePlaceholder: 'Назва модуля',
        addModuleBtn: 'Додати',
        cancel: 'Скасувати',
        noModules: 'Немає модулів',
        noModulesHint: 'Створіть перший модуль, щоб додати уроки',
        expandTooltip: 'Розгорнути',
        collapseTooltip: 'Згорнути',
        lessonCount: '{{count}} {{noun}}',
        editModuleTooltip: 'Редагувати модуль',
        duplicateModuleTooltip: 'Дублювати модуль з усім змістом',
        duplicateSuffix: '(копія)',
        deleteModuleTooltip: 'Видалити модуль',
        moduleTestLabel: 'Модульний тест:',
        moduleTestNone: '— не вибрано —',
        newTest: '+ Новий',
        newTestTooltip: 'Створити новий тест',
        noLessonsInModule: 'Немає уроків. Додайте урок або перетягніть з іншого модуля.',
        addLesson: 'Додати урок',
      },
      lessonNouns: {
        one: 'урок',
        few: 'уроки',
        many: 'уроків',
      },
      specialSection: {
        heading: 'Спеціальні уроки',
        addBtn: 'Додати спецурок',
        description: 'Спеціальні уроки (день народження, свята тощо) які вчитель може призначити замість звичайного уроку. Програма просто зсунеться.',
        addFormHeading: 'Додати спеціальний урок',
        presentationLabel: 'Презентація *',
        pickPresentation: 'Оберіть презентацію...',
        presentationStats: '({{count}} слайдів)',
        noPresentations: 'Немає презентацій. Створіть їх у розділі "Презентації".',
        categoryLabel: 'Категорія *',
        pickCategory: 'Оберіть категорію...',
        newCategoryBtn: '+ Нова',
        noCategories: 'Немає категорій. Створіть нову категорію.',
        newCategoryHeading: 'Нова категорія',
        nameUkLabel: 'Назва (українською) *',
        nameUkPlaceholder: 'Наприклад: День народження',
        nameEnLabel: 'Назва (англійською)',
        nameEnPlaceholder: 'Наприклад: Birthday',
        creating: 'Створення...',
        createBtn: 'Створити',
        cancel: 'Скасувати',
        customTitleLabel: 'Власна назва (необов\'язково)',
        customTitlePlaceholder: 'Якщо не вказано, буде використано назву презентації',
        addBtnForm: 'Додати',
        empty: 'Немає спеціальних уроків',
        emptyHint: 'Додайте уроки для свят та особливих подій',
        slideCount: '{{count}} слайдів',
        deleteTooltip: 'Видалити',
      },
      repetitionSection: {
        heading: 'Уроки повторення',
        addBtn: 'Додати урок повторення',
        description: 'Уроки для повторення матеріалу, які вчитель може призначити замість звичайного уроку. Програма зсунеться.',
        addFormHeading: 'Додати урок повторення',
        presentationLabel: 'Презентація *',
        pickPresentation: 'Оберіть презентацію...',
        presentationStats: '({{count}} слайдів)',
        noPresentations: 'Немає презентацій. Створіть їх у розділі "Презентації".',
        customTitleLabel: 'Власна назва (необов\'язково)',
        customTitlePlaceholder: 'Якщо не вказано, буде використано назву презентації',
        addBtnForm: 'Додати',
        cancel: 'Скасувати',
        empty: 'Немає уроків повторення',
        emptyHint: 'Додайте уроки для повторення матеріалу',
        slideCount: '{{count}} слайдів',
        deleteTooltip: 'Видалити',
      },
    },
    editorView: {
      touchMenuCopy: 'Копіювати',
      touchMenuDuplicate: 'Дублювати',
      touchMenuPaste: 'Вставити',
      touchMenuDelete: 'Видалити',
      canvaBlocked: 'Canva не дозволяє копіювати зображення',
      canvaBlockedHint: 'Завантажте зображення з Canva (Share → Download), потім перетягніть файл на слайд або скопіюйте його.',
      miroBlocked: 'Miro не дозволяє копіювати зображення',
      miroBlockedHint: 'Завантажте зображення з Miro (Export), потім перетягніть файл на слайд.',
      saveErrorTitle: 'Помилка збереження',
      saveErrorMessage: 'Якщо продовжити редагування, зміни не збережуться. Перезавантажте сторінку.',
      reload: 'Перезавантажити',
      loadingPresentation: 'Завантаження презентації...',
      presentationNotFound: 'Презентацію не знайдено',
      unsupportedType: 'Непідтримуваний тип',
      frameMediaOnly: 'У рамку можна вставити лише зображення або відео',
      fileTooLarge: 'Файл занадто великий',
      maxSize: 'Максимальний розмір: {{size}}',
      errorTitle: 'Помилка',
      frameUploadFailed: 'Не вдалося завантажити медіа в рамку: {{message}}',
      unsupportedFileType: 'Непідтримуваний тип файлу',
      supportedTypesHint: 'Підтримуються лише зображення, відео та аудіо файли',
      fileTooLargeForType: 'Файл занадто великий',
      maxSizeForType: 'Максимальний розмір для {{type}}: {{size}}',
      typeImages: 'зображень',
      typeVideo: 'відео',
      typeAudio: 'аудіо',
      uploadFailed: 'Помилка при завантаженні файлу на сервер',
      newText: 'Новий текст',
      imageAlt: 'Зображення',
      inputPlaceholder: 'Введіть відповідь...',
      notebookPlaceholder: 'Пиши тут…',
      wheelOption: 'Варіант {{n}}',
      flipQuestion: 'Питання',
      flipAnswer: 'Відповідь',
      stickerAlt: 'Стікер',
      enterQuestion: 'Введіть питання...',
      option: 'Варіант {{n}}',
      bookCoverDefault: 'Моя книга',
      bookPageDefault: 'Сторінка {{n}}',
      word: 'СЛОВО',
      fruits: 'Фрукти',
      vegetables: 'Овочі',
      apple: 'Яблуко',
      banana: 'Банан',
      carrot: 'Морква',
      cucumber: 'Огірок',
      rankItem1: 'Найбільший',
      rankItem2: 'Великий',
      rankItem3: 'Маленький',
      rankItem4: 'Найменший',
      answer: 'відповідь',
      readAndWrite: 'Прочитайте твердження і напишіть T, F або N',
      chooseCorrectAnswer: 'Choose the correct answer',
      pickCorrectVariant: 'Оберіть правильний варіант',
      findAndFixMistake: 'Знайдіть помилку в реченні та виправте її',
      word1: 'Слово 1',
      translation1: 'Переклад 1',
      word2: 'Слово 2',
      translation2: 'Переклад 2',
      word3: 'Слово 3',
      translation3: 'Переклад 3',
      word4: 'Слово 4',
      imageTooLarge: 'Зображення занадто велике',
      maxSize10MB: 'Максимальний розмір: 20MB',
      insertedImageAlt: 'Вставлене зображення',
      uploadImageFailed: 'Не вдалося завантажити зображення',
      insertImageFailedTitle: 'Не вдалося вставити зображення',
      insertImageFailedHint: 'Деякі сервіси (Canva, Miro) не дозволяють копіювати зображення. Спробуйте завантажити зображення на комп\'ютер, а потім скопіюйте його.',
      successTitle: 'Успішно',
      presentationSaved: 'Презентацію збережено!',
      presentationSaveFailed: 'Помилка збереження презентації',
      personalizedBanner: 'Ви редагуєте персоналізовану версію презентації для одного уроку. Оригінал не зміниться.',
    },
  },
  en: {
    header: {
      saved: 'Saved',
      saving: 'Saving',
      error: 'Error',
      preview: 'Preview',
      aiGenerate: 'AI lesson',
    },
    ai: {
      title: 'Generate lesson with AI',
      modeFull: 'Full presentation',
      modeSlide: 'Single slide',
      topic: 'Lesson topic',
      topicPlaceholder: 'e.g. Past Simple, Food vocabulary, Daily routines',
      lessonTitle: 'Lesson title (optional)',
      lessonTitlePlaceholder: 'e.g. At the movies: what shall we watch this weekend?',
      lessonTitleHint: 'If set, the AI will use this exact title on the cover slide.',
      level: 'Level',
      focus: 'Focus',
      focusMixed: 'Mixed',
      focusVocab: 'Vocabulary',
      focusGrammar: 'Grammar',
      focusReading: 'Reading',
      focusSpeaking: 'Speaking',
      audienceType: 'Audience type',
      audienceKids: 'Kids',
      audienceAdults: 'Adults',
      audience: 'Details (optional)',
      audiencePlaceholder: 'e.g. beginners, 8–10 y.o., business English',
      slidesCount: 'Slides: {{count}}',
      extraContext: 'Additional context',
      extraContextHint: 'Target words, grammar point, teacher notes — anything that helps the AI.',
      extraContextPlaceholder: "e.g. words: apple, bread, cheese; practice 'there is / there are'",
      references: 'Slide references (style)',
      referencesHint: 'Up to 20 reference slides. The AI will match the style (layout, elements, colors), not the content.',
      referencesAdd: 'Add reference',
      referencesEmpty: 'No references yet. Add slides whose style the AI should mirror.',
      referencesRole: 'Role in lesson arc',
      referencesSearchPresentation: 'Find a presentation',
      referencesSearchPlaceholder: 'Presentation title…',
      referencesSearchEmpty: 'Nothing found',
      referencesPickSlide: 'Slide number',
      referencesPickSlideHint: 'Comma-separated for multiple, e.g. 2, 5, 7',
      referencesBrowseSlides: 'Or pick slides visually',
      referencesSlidesLoadError: 'Failed to load slides',
      referencesAddButton: 'Add',
      referencesRemove: 'Remove',
      referencesLimit: 'Maximum 20 references',
      cancel: 'Cancel',
      generate: 'Generate',
      generating: 'Generating...',
      generatingHint: 'Generation can take up to 10 minutes. Please don\'t close this window.',
    },
    toolbar: {
      undo: 'Undo (Ctrl+Z)',
      redo: 'Redo (Ctrl+Shift+Z)',
      text: 'Text (T)',
      shapes: 'Shapes (S)',
      rectangle: 'Rectangle',
      square: 'Square',
      circle: 'Circle',
      oval: 'Oval',
      triangle: 'Triangle',
      messageBubble: 'Speech bubble',
      roundedMessageBubble: 'Speech bubble (rounded)',
      straightArrow: 'Arrow — straight (click and drag)',
      curvedArrow: 'Arrow — curved (draw freehand, will smooth)',
      image: 'Image (I)',
      video: 'Video',
      youtubeVideo: 'YouTube video',
      audio: 'Audio',
      sound: 'Sound (short, no controls)',
      elements: 'Elements',
      exercises: 'Exercises',
      games: 'Games',
      stickers: 'Stickers',
      frames: 'Frames (phone, TV) — can hold video',
      photos: 'Photos',
      grid: 'Grid:',
      showGrid: 'Show grid',
      hideGrid: 'Hide grid',
      enableSnap: 'Enable snap to grid',
      disableSnap: 'Disable snap to grid',
      gridSize: 'Grid size',
      enableSmartGuides: 'Enable Smart Guides',
      disableSmartGuides: 'Disable Smart Guides',
      zoom: 'Zoom:',
      zoomOut: 'Zoom out',
      zoomLevel: 'Zoom level',
      zoomIn: 'Zoom in',
      savedTemplates: 'Saved ({{count}})',
      deleteTemplate: 'Delete template',
      deleteTemplateTitle: 'Delete template?',
      deleteTemplateMessage: 'Delete template "{{name}}"?',
      alignment: 'Alignment',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      alignLeft: 'Left',
      alignCenter: 'Center',
      alignRight: 'Right',
      alignTop: 'Top',
      alignMiddle: 'Middle',
      alignBottom: 'Bottom',
      duplicate: 'Duplicate (Ctrl+D)',
      group: 'Group (Ctrl+G)',
      ungroup: 'Ungroup (Ctrl+Shift+G)',
      delete: 'Delete',
      addSlide: 'Add slide',
    },
    elementsPanel: {
      searchPlaceholder: 'Search elements...',
      interactive: 'Interactive',
      exercises: 'Exercises',
      games: 'Games',
      items: {
        aliasGame: { name: 'Alias', description: 'Explain words to your partner in 60 seconds — learner and teacher take turns' },
        tabooGame: { name: 'Taboo', description: 'Explain the word without using the forbidden words below it' },
        whoAmIGame: { name: 'Who Am I?', description: 'Learner asks yes/no questions to guess the picture. Optional time attack.' },
        inputField: { name: 'Input field', description: 'Students can type text' },
        notebook: { name: 'Notebook', description: 'Student writes on lined paper — teacher sees it live' },
        spinWheel: { name: 'Spin wheel', description: 'Spin for a random pick' },
        flipCard: { name: 'Flip card', description: 'Card with two sides' },
        dice: { name: 'Dice', description: 'Roll the dice' },
        checkbox: { name: 'Checkbox', description: 'Small box to tick' },
        like: { name: 'Like', description: 'Heart — tap to fill it red' },
        rating: { name: 'Rating', description: 'A row of stars for rating' },
        shop: { name: 'Shop', description: 'Price tags on the slide — student buys within budget' },
        cardDeck: { name: 'Card deck', description: 'Two decks — student flips the top card and drops it in the neighbouring deck' },
        book: { name: 'Book', description: 'Student taps the cover, then turns pages with text and images' },
        highlight: { name: 'Highlight', description: 'Student taps a spot on the slide — a shape appears (line, circle, oval, cross)' },
        smittnik: { name: 'Trash bin', description: 'Drag movable elements into the bin — they stay inside' },
        bingo: { name: 'Bingo', description: 'A grid of squares with text or images — student taps a cell to cross it out' },
        memory: { name: 'Memory', description: 'Match pairs: student flips cards and finds word ↔ image matches' },
        personalityQuiz: { name: 'Quiz', description: 'One question at a time, student picks what fits best — a result at the end ("Which princess are you?")' },
        kissMarryAvoid: { name: 'Kiss / Marry / Avoid', description: 'Three characters — student gives each one Kiss, Marry or Avoid (each option only once)' },
        dressUp: { name: 'Dress-up', description: 'A character and a wardrobe — the student picks outfits and dresses the character' },
        boardGame: { name: 'Board game', description: 'A path of task cells — players roll the die and move in turns' },
        spotDifference: { name: 'Spot the difference', description: 'Two pictures — the student clicks the differences, they get circled on both' },
        mindMap: { name: 'Mind map', description: 'Topic in the centre — the student adds branches and ideas around it' },
        dialogue: { name: 'Dialogue simulator', description: 'Chat with a character — the student picks replies, choices steer the conversation' },
        pictionaryGame: { name: 'Pictionary', description: 'Draw a word, the other guesses. Student ↔ teacher or teams' },
        table: { name: 'Table', description: 'Grid of rows and columns' },
        puzzle: { name: 'Puzzle', description: 'Student drags jigsaw pieces into a frame to reveal the picture' },
        singleChoice: { name: 'Single answer', description: 'Pick the one correct answer' },
        multipleChoice: { name: 'Multiple answers', description: 'Pick all correct answers' },
        anagram: { name: 'Anagram', description: 'Build a word from shuffled letters' },
        wordsearch: { name: 'Wordsearch', description: 'Connect adjacent letters to form words' },
        boggle: { name: 'Boggle', description: 'Build words from scattered letters — no adjacency needed' },
        oddOneOut: { name: 'Odd one out', description: 'Pick the odd item in each row' },
        sorting: { name: 'Sorting', description: 'Drag items into the correct categories (table or baskets)' },
        unjumble: { name: 'Unjumble sentence', description: 'Drag words to build the sentence in the right order' },
        rank: { name: 'Rank', description: 'Student puts items in order from first to last (vertical or horizontal)' },
        orderSentences: { name: 'Order sentences', description: 'Student drags sentences in a column to put them in the correct order' },
        dragLabelImage: { name: 'Labels on image', description: 'Drag labels onto the correct spots' },
        dragLabelText: { name: 'Labels in text', description: 'Drag labels into gaps in the text' },
        dragLabelBlank: { name: 'Labels on slide', description: 'Place slots anywhere and drag labels from the panel' },
        matchLines: { name: 'Match with lines', description: 'Student connects pairs of dots with lines' },
        labelImage: { name: 'Label the image', description: 'Student connects word labels to dots on an image' },
        typeAnswer: { name: 'Type the answer', description: 'Student types the answer into a field' },
        trueFalse: { name: 'True / False', description: 'Students type T, F (or N) in the boxes' },
        abcd: { name: 'ABCD', description: 'Questions with 2–4 options — student circles the correct one' },
        chooseWord: { name: 'Choose word', description: 'Sentence has two options separated by / — student picks the right one' },
        fixMistake: { name: 'Fix the mistake', description: 'Sentence has a mistake — student taps a word and types the correction' },
        fillGaps: { name: 'Fill the gaps', description: 'Student types answers into gaps in the text' },
        tableFill: { name: 'Fill the table', description: 'Student types answers into table cells' },
        missingLetters: { name: 'Missing letters', description: 'Some letters of a word are hidden — student types them into the empty boxes' },
        pronounce: { name: 'Pronounce', description: 'Student pronounces the word into the mic — accuracy becomes stars' },
        findObject: { name: 'Find object', description: 'Student finds the named object in the image and taps it' },
        findSticker: { name: 'Find sticker', description: 'Place stickers on the image — student reads the word and taps the matching sticker' },
        nmtImage: { name: 'NMT picture', description: 'Student sees a picture and chooses the correct answer from lettered options (A, B, C…)' },
      },
    },
    cardDeck: {
      title: 'Card deck',
      subtitle: 'Student taps the top card — it flips and moves to the neighbouring deck',
      cards: 'Cards',
      addCard: 'Add',
      emptyHint: 'Add cards — set text or an image for the front and back of each.',
      removeCard: 'Remove card',
      front: 'Front',
      back: 'Back',
      textPlaceholder: 'Text',
      uploadImage: 'Photo',
      fontSize: 'Text size',
      colors: 'Colors',
      frontBg: 'Front · bg',
      frontText: 'Front · text',
      backBg: 'Back · bg',
      backText: 'Back · text',
    },
    book: {
      title: 'Book',
      subtitle: 'Student taps the cover to open the book, then taps a page to turn it',
      cover: 'Cover',
      coverTitlePlaceholder: 'Book title',
      coverDefault: 'My book',
      coverBg: 'Background',
      coverText: 'Text',
      pages: 'Pages',
      addPage: 'Add',
      pageLabel: 'Page',
      textPlaceholder: 'Page text',
      uploadImage: 'Photo',
      moveUp: 'Up',
      moveDown: 'Down',
      removePage: 'Remove page',
      emptyHint: 'Add pages — set text or an image for each.',
      editorEmpty: 'Add pages in the properties panel on the right',
      fontSize: 'Text size',
      coverFontSize: 'Cover text size',
      pageFontSize: 'Page text size',
      coverFont: 'Cover font',
      pageFont: 'Page font',
      pageColor: 'Page background',
      textColor: 'Text color',
      bold: 'Bold',
      italic: 'Italic',
      alignLeft: 'Align left',
      alignCenter: 'Align center',
      alignRight: 'Align right',
    },
    highlight: {
      shape: 'Highlight shape',
      color: 'Color',
      strokeWidth: 'Line thickness',
      hint: 'When the student taps the element, the shape appears. Tapping again hides it.',
      shapes: {
        underline: 'Underline',
        circle: 'Circle',
        oval: 'Oval',
        cross: 'Cross',
      },
    },
    bingo: {
      title: 'Bingo',
      subtitle: 'Grid of squares — the student taps a square and it gets crossed out',
      rows: 'Rows',
      cols: 'Columns',
      cells: 'Cells',
      cellPlaceholder: 'Text',
      uploadImage: 'Photo',
      fontSize: 'Font size',
      font: 'Font',
      cellBg: 'Cell background',
      textColor: 'Text color',
      borderColor: 'Border color',
      crossColor: 'Cross color',
      borderWidth: 'Border width',
    },
    stickerPanel: {
      searchPlaceholder: 'Search stickers...',
      notFound: 'No stickers found',
      empty: 'No stickers',
      addInAdmin: 'Add stickers in the admin panel',
    },
    framePanel: {
      title: 'Frames',
      subtitle: 'You can drop a photo or video inside',
      empty: 'No frames',
      addInAdmin: 'Add frames in the admin panel',
    },
    photoPanel: {
      searchPlaceholder: 'Search photos...',
      notFound: 'No photos found',
      empty: 'No photos',
      addInAdmin: 'Add photos in the admin panel',
    },
    colorPicker: {
      transparent: 'Transparent',
      eyedropper: 'Eyedropper — pick a color from the screen',
    },
    saveTemplate: {
      title: 'Save as template',
      slide: 'Slide {{index}}',
      nameLabel: 'Template name',
      namePlaceholder: 'For example: Welcome slide, Matching exercise...',
    },
    starThresholds: {
      title: 'Stars for words found',
      wordsFound: 'Words found (≥)',
      stars: 'Stars',
      note: 'The student gets as many stars as the tier reached by number of words found. 0 words — 0 stars.',
    },
    layers: {
      title: 'Layers',
      empty: 'No elements on the slide',
      hint: 'Top row is the front. Drag to reorder.',
      childrenCount: '{{count}} elements',
      elementFallback: 'Element',
    },
    textStyle: {
      title: 'Text style',
      size: 'Size',
      color: 'Color',
      pickColor: 'Pick text color',
    },
    canvas: {
      dropFile: 'Drop file here',
      dropFileHint: 'Image, video or audio',
      dropIntoFrame: 'Release to insert into frame',
      rotate: 'Rotate',
      lock: 'Lock position',
      unlock: 'Unlock',
      group: 'Group ({{count}})',
      linkToSlide: 'Slide',
      emptySlide: 'Empty slide',
    },
    elementLabels: {
      text: 'Text',
      shape: 'Shape',
      arrow: 'Arrow',
      image: 'Image',
      video: 'Video',
      youtubeVideo: 'YouTube',
      audio: 'Audio',
      sound: 'Sound',
      sticker: 'Sticker',
      group: 'Group',
      table: 'Table',
      inputField: 'Input field',
      notebook: 'Notebook',
      spinWheel: 'Spin wheel',
      flipCard: 'Flip card',
      dice: 'Dice',
      checkbox: 'Checkbox',
      like: 'Like',
      rating: 'Rating',
      shop: 'Shop',
      cardDeck: 'Card deck',
      book: 'Book',
      highlight: 'Highlight',
      memory: 'Memory',
      personalityQuiz: 'Quiz',
      kissMarryAvoid: 'Kiss / Marry / Avoid',
      dressUp: 'Dress-up',
      boardGame: 'Board game',
      spotDifference: 'Spot the difference',
      mindMap: 'Mind map',
      dialogue: 'Dialogue simulator',
      singleChoice: 'Single answer',
      multipleChoice: 'Multiple answers',
      anagram: 'Anagram',
      aliasGame: 'Alias',
      whoAmIGame: 'Who Am I?',
      oddOneOut: 'Odd one out',
      sorting: 'Sorting',
      unjumble: 'Unjumble',
      rank: 'Rank',
      orderSentences: 'Order sentences',
      dragLabelImage: 'Labels on image',
      dragLabelText: 'Labels in text',
      dragLabelBlank: 'Labels on slide',
      matchLines: 'Match with lines',
      labelImage: 'Label the image',
      typeAnswer: 'Type the answer',
      chooseWord: 'Choose word',
      fixMistake: 'Fix the mistake',
      fillGaps: 'Fill the gaps',
      tableFill: 'Fill the table',
      missingLetters: 'Missing letters',
      pronounce: 'Pronounce',
      nmtImage: 'NMT picture',
    },
    properties: {
      title: 'Properties',
      slideTitle: 'Slide properties',
      settings: 'Settings',
      appearance: 'Appearance',
      behavior: 'Behavior',
      backgroundColor: 'Background color',
      readyGradients: 'Preset gradients',
      gradient: 'Gradient',
      opacity: 'Opacity',
      rotation: 'Rotation',
      borderRadius: 'Corner radius',
      cloneOnDrag: 'Clone on drag',
      cloneOnDragHint: 'Student drags copies; the original stays in place',
      gifPlayback: 'GIF playback',
      gifPlaybackLoop: 'Loop',
      gifPlaybackLoopHint: 'Plays continuously while the slide is open',
      gifPlaybackClick: 'On click',
      gifPlaybackClickHint: 'Plays when the teacher clicks the GIF',
      gifPlaybackSlide: 'On slide open',
      gifPlaybackSlideHint: 'Plays once when the slide opens',
      filtersSection: 'Image filters',
      filtersReset: 'Reset',
      filterBrightness: 'Brightness',
      filterContrast: 'Contrast',
      filterSaturation: 'Saturation',
      filterHue: 'Hue',
      filterBlur: 'Blur',
      filterSepia: 'Sepia',
      filterGrayscale: 'Grayscale',
      strokeWidth: 'Stroke width',
      strokeColor: 'Stroke color',
      fill: 'Fill',
      stroke: 'Stroke',
      backgroundElement: 'Background element',
      teacherOnly: 'Visible only to teacher during the lesson',
      showLayers: 'Show layers',
      showLayersPanel: 'Show layers panel',
      hint: 'Hints, timings, answers…',
      selectionCount: '{{count}} elements selected',
      group: 'Group',
      groupBtn: 'Group',
      ungroupBtn: 'Ungroup',
      layer: 'Layer',
      toFront: 'Bring to front',
      toBack: 'Send to back',
      moveForward: 'Move forward (one layer up)',
      moveBackward: 'Move backward (one layer down)',
      shapeType: 'Shape type',
      color1: 'Color 1',
      color2: 'Color 2',
      glowColor: 'Glow color',
      elementBackground: 'Element background',
      font: 'Font',
      fontSize: 'Font size',
      textColor: 'Text color',
      bold: 'Bold',
      italic: 'Italic',
      lineHeight: 'Line spacing',
      bulletedList: 'Bulleted list',
      numberedList: 'Numbered list',
      alignment: 'Alignment',
      alignLeft: 'Left',
      alignCenter: 'Center',
      alignRight: 'Right',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      leftToRight: 'Left to right',
      rightToLeft: 'Right to left',
      topToBottom: 'Top to bottom',
      bottomToTop: 'Bottom to top',
      diagTopLeft: 'Diagonal top-left',
      diagTopRight: 'Diagonal top-right',
      diagBottomLeft: 'Diagonal bottom-left',
      diagBottomRight: 'Diagonal bottom-right',
      flip: 'Flip',
      flipHorizontal: 'Flip horizontally',
      flipVertical: 'Flip vertically',
      perspective: 'Perspective',
      perspectiveVertical: 'Vertical',
      perspectiveHorizontal: 'Horizontal',
      resetPerspective: 'Reset perspective',
      lists: 'Lists',
      strokeWidthLine: 'Line thickness',
      headSize: 'Arrowhead size',
      videoSettings: 'Video settings',
      autoplay: 'Autoplay',
      autoplayMuted: 'Autoplay (muted)',
      muted: 'Muted',
      loop: 'Loop',
      selectFile: 'Choose file',
      selectVideoOrPhoto: 'Choose video or photo',
      replaceFile: 'Replace file',
      uploadImage: 'Upload image',
      uploadAudio: 'Upload audio',
      uploadVideo: 'Upload video',
      uploadSound: 'Upload sound',
      deleteSound: 'Delete sound',
      soundAdded: 'Sound added',
      or: 'or',
      orDragHere: 'or drag here',
      allowedFormatsImage: 'Allowed formats: JPEG, PNG, GIF, WebP',
      allowedFormatsAudio: 'Allowed formats: MP3, WAV, OGG, M4A',
      maxFileSize: 'Max file size: 20MB',
      loading: 'Loading…',
      loadingDots: 'Loading...',
      invalidFormat: 'Invalid format',
      fileTooLarge: 'File too large',
      soundTooLong: 'Sound too long',
      cannotReadAudio: 'Could not read audio file',
      uploadImageError: 'Image upload failed',
      uploadSoundError: 'Sound upload failed',
      diceType: 'Dice type',
      diceColor: 'Dice color',
      dotsColor: 'Dots / number color',
      spinDurationMs: 'Spin duration (ms)',
      inputType: 'Field type',
      singleLineText: 'Text (single line)',
      multiLineText: 'Text (multi-line)',
      maxChars: 'Max chars',
      studentCanEdit: 'Students can edit',
      studentCanDrag: 'Students can drag',
      flipDirection: 'Flip direction',
      front: 'Front side',
      back: 'Back side',
      frontText: 'Front side text...',
      backText: 'Back side text...',
      chooseFromStickers: 'Choose from stickers',
      hintText: 'Hint text...',
      checkColor: 'Check color',
      heartColor: 'Heart color',
      starColor: 'Star color',
      starCount: 'Number of stars',
      cellBg: 'Cell background',
      headerBg: 'Header background',
      headerColor: 'Header color',
      headerText: 'Header text',
      firstRowHeader: 'First row is header',
      rows: 'Rows ({{count}})',
      columns: 'Columns ({{count}})',
      always: 'Always',
      clickOnly: 'Click / off',
      clickNoOff: 'Click without off',
      collapse: 'Collapse',
      expand: 'Expand',
      enable: 'Enable',
      addTag: 'Add at least one label',
      addTwoPairs: 'Add at least two pairs',
      addFrames: 'Add frames',
      addLetters: 'Add letters',
      wordsMissingLetters: 'Some words are missing letters in the pool. Add letters or change the words.',
      wordsNotFormable: 'Some words cannot be formed from this grid. Check the letters or change the words.',
      pair: 'Pair #{{index}}',
      allowRetry: 'Allow retry',
      retry: 'Retry',
      pointDot: 'Dot',
      onTime: 'Timed',
      accuracyThreshold: 'Accuracy (0.0–1.0) ≥',
      findWholeWords: 'Find full words',
      variantNo: 'Option "N" (no information)',
      poolPosition: 'Element pool position',
      letters: 'Letters',
      doubleClickToEdit: 'Double-click text to edit',
      pickFile: 'Choose file',
      // Extended properties keys for PropertiesPanel
      slideLink: 'Slide link',
      slideOption: 'Slide {{index}}',
      removeSlideLink: 'Remove link',
      addSlideLink: '+ Add slide link',
      selectionHint: 'Settings shown for the first only. Group actions available: move, Delete, Ctrl+D (duplicate), Ctrl+G (group).',
      groupSelected: 'Group',
      groupTooltip: 'Group (Ctrl+G)',
      ungroupTooltip: 'Ungroup (Ctrl+Shift+G)',
      fixed: 'Fixed',
      movable: 'Movable',
      editable: 'Editable',
      highlight: 'Highlight',
      textStyle: 'Text style',
      shapeRectangle: 'Rectangle',
      shapeSquare: 'Square',
      shapeCircle: 'Circle',
      shapeOval: 'Oval',
      shapeTriangle: 'Triangle',
      shapeMessageBubble: 'Message bubble',
      shapeRoundedMessageBubble: 'Message bubble (rounded)',
      allowedFormatsImageWithSize: 'JPEG, PNG, GIF, WebP (max 5MB)',
      allowedFormatsVideoWithSize: 'MP4, WebM, OGG (max 500MB)',
      allowedFormatsAudioWithSize: 'MP3, WAV, OGG (max 20MB)',
      videoUrl: 'Video URL',
      youtubeUrl: 'YouTube URL',
      youtubeInvalidUrl: 'Could not detect a YouTube video. Paste a link like https://www.youtube.com/watch?v=... or https://youtu.be/...',
      audioUrl: 'Audio URL',
      frameMedia: 'Media inside frame',
      frameMediaFormats: 'Video: MP4/WebM (up to 500MB) · Photo: JPG/PNG/WebP (up to 20MB)',
      deleteFrameMedia: 'Remove media from frame',
      frameMediaPosition: 'Media position',
      frameMediaAdjust: 'Adjust position',
      frameMediaAdjustDone: 'Done',
      frameMediaAdjustHint: 'Drag to move · Scroll to zoom',
      frameMediaZoom: 'Zoom',
      frameMediaReset: 'Reset',
      frameVideoTrim: 'Trim video',
      frameVideoTrimStart: 'Start',
      frameVideoTrimEnd: 'End',
      frameVideoTrimDuration: 'Length',
      frameVideoTrimLoading: 'Loading duration…',
      soundFormatsShort: 'MP3, WAV, OGG. Up to {{seconds}}s. No seek or pause.',
      soundFormatsHint: 'Up to {{seconds}}s. No seek or pause — plays on icon click.',
      sound: 'Sound',
      placeholderLabel: 'Placeholder',
      hintTextPlaceholder: 'Hint text...',
      notebookTitle: 'Title (optional)',
      notebookTitlePlaceholder: 'e.g., Homework',
      notebookLineSpacing: 'Line spacing (px)',
      notebookLineColor: 'Line color',
      segments: 'Segments ({{count}}/12)',
      optionPlaceholder: 'Option {{index}}',
      optionText: 'Option {{index}}',
      addOption: '+ Add option',
      resetRotation: 'Reset rotation',
      teacherNotes: 'Teacher notes',
      teacherNotesVisibility: 'Visible only to the teacher during the lesson',
      teacherNotesPlaceholder: 'Hints, timings, answers…',
      teacherNotesBold: 'Bold',
      teacherNotesItalic: 'Italic',
      teacherNotesBulletList: 'Bulleted list',
      teacherNotesNumberedList: 'Numbered list',
      teacherNotesImage: 'Add photo',
      gradientDirection: 'Direction',
      gradientPresetPurple: 'Purple',
      gradientPresetGreen: 'Green',
      gradientPresetPink: 'Pink',
      gradientPresetSunset: 'Sunset',
      gradientPresetBlue: 'Blue',
      gradientPresetCoral: 'Coral',
      gradientPresetPeach: 'Peach',
      gradientPresetPastel: 'Pastel',
      invalidFormatTitle: 'Invalid format',
      fileTooLargeTitle: 'File too large',
      errorTitle: 'Error',
      soundTooLongTitle: 'Sound too long',
      soundMaxDuration: 'Max duration: {{seconds}} seconds',
      failedReadAudio: 'Could not read audio file',
      soundUploadError: 'Sound upload failed',
      imageUploadError: 'Image upload failed',
      allowedFormatsAudioList: 'Allowed formats: MP3, WAV, OGG, M4A',
      maxFileSize10MB: 'Max file size: 20MB',
      allowedFormatsImageList: 'Allowed formats: JPEG, PNG, GIF, WebP',
    },
    configPanels: {
      common: {
        allowRetryTitle: 'Retry',
        allowRetryOn: 'Student can try again',
        allowRetryOff: 'Only one attempt',
        pickColor: 'Pick a color',
        transparent: 'Transparent',
        actionBarButton: 'Background of the bar with the "Check" button',
        actionBarBg: 'Bar background',
        actionBarPickTransparent: 'Pick transparent or a custom color',
        colorPresetGreen: 'Green',
        colorPresetIndigo: 'Indigo',
        colorPresetTeal: 'Teal',
        colorPresetRed: 'Red',
        colorPresetOrange: 'Orange',
        colorPresetPurple: 'Purple',
        colorPresetDarkGreen: 'Dark green',
        tileColor: 'Tile color',
        checkButtonColor: '"Check" button color',
        font: 'Font',
        textSize: 'Text size ({{size}}px)',
        deleteBtn: 'Delete',
        deleteImage: 'Delete image',
        addLabel: 'Add',
        correctLabelPlaceholder: '— correct label —',
        slots: 'Slots ({{count}})',
        labels: 'Labels ({{count}})',
        labelText: 'Label text',
        addAtLeastOneLabel: 'Add at least one label',
        extraLabel: 'extra',
        extraLabelTooltip: 'This label is not tied to any slot — it will be a distractor',
        deleteSlot: 'Delete slot',
        slotWidth: 'W',
        slotHeight: 'H',
        slotSize: 'size',
        paletteSide: 'Palette position',
        paletteTop: 'Top',
        paletteBottom: 'Bottom',
        paletteLeft: 'Left',
        paletteRight: 'Right',
        uploadingImage: 'Uploading…',
        dropToUpload: 'Drop to upload',
        uploadImage: 'Upload image',
        orDragHere: 'or drag here',
        uploadFailed: 'Upload failed',
        uploadImageFailed: 'Could not upload the image',
        serverNoImageUrl: 'Server did not return imageUrl',
        invalidFormat: 'Invalid format',
        allowedFormatsImage: 'Allowed formats: JPEG, PNG, GIF, WebP',
        fileTooLarge: 'File too large',
        maxSize10MB: 'Max size: 20MB',
        dragToReorder: 'Drag to reorder',
        instruction: 'Instruction (optional)',
        correct: 'Correct:',
        addAtLeastOneSentence: 'Add at least one sentence',
      },
      anagram: {
        title: 'Anagram',
        subtitle: 'The student has to build a word from shuffled letters',
        wordLabel: 'Word to guess',
        wordPlaceholder: 'Enter a word...',
        wordHint: 'Up to 12 letters. Letters will be shuffled automatically.',
        preview: 'Preview',
        hintLabel: 'Hint (optional)',
        hintPlaceholder: 'For example: Month of the year',
        validationMinLetters: 'Enter a word (at least 2 letters)',
      },
      alias: {
        title: 'Alias',
        subtitle: 'Learner and teacher take turns explaining words to each other for 1 minute. How many will you cover?',
        addWordLabel: 'Add a word',
        addWordPlaceholder: 'Word or phrase',
        addButton: 'Add',
        bulkHint: 'You can paste multiple words separated by commas or new lines.',
        importFromFile: 'Import from file',
        importSuccess: 'Added {{added}} words from file.',
        importSuccessTruncated: 'Added {{added}} words. Skipped {{dropped}} more (max 1000 per import).',
        importEmpty: 'No words found in the file.',
        importReadError: 'Could not read the file.',
        pasteListButton: 'Paste list',
        pasteListPlaceholder: 'Paste words: one per line, or separated by commas / semicolons',
        pastePreview: 'Will add: {{count}}',
        pasteAddAll: 'Add all',
        pasteCancel: 'Cancel',
        wordsLabel: 'Words',
        emptyList: 'No words yet. Add at least one to make the game playable.',
        removeWord: 'Remove word',
        validationEmpty: 'Add at least one word to save the game.',
        recommendation: 'Recommended: 10+ words for a full 2-minute game.',
      },
      taboo: {
        title: 'Taboo',
        subtitle: 'Learner and teacher take turns explaining words for 1 minute without saying the forbidden words below them.',
        addCard: 'Add card',
        wordPlaceholder: 'Word to explain',
        forbiddenPlaceholder: 'Forbidden words, comma-separated',
        removeCard: 'Remove card',
        pasteListButton: 'Paste list',
        pasteHint: 'One card per line: word, colon, forbidden words separated by commas.',
        pastePreview: 'Cards to add: {{count}}',
        pasteAddAll: 'Add all',
        pasteCancel: 'Cancel',
        importSuccess: 'Added {{added}} cards.',
        importSuccessTruncated: 'Added {{added}} cards. Skipped {{dropped}} more (max 500 per import).',
        cardsLabel: 'Cards',
        emptyList: 'No cards yet. Add at least one to make the game playable.',
        validationEmpty: 'Add at least one card with a word.',
        missingForbidden: 'Some cards have no forbidden words.',
        recommendation: 'Recommended: 10+ cards for a full 2-minute game.',
      },
      boggle: {
        title: 'Wordsearch',
        subtitle: 'Student connects adjacent letters in the grid to build words.',
        gameMode: 'Game mode',
        modeTargets: 'Find targets',
        modeTime: 'Timed',
        modeTargetsHint: 'The student must find all targets. Other words will count as "bonus".',
        modeTimeHint: 'The student finds as many words as possible in the given time.',
        gridSize: 'Grid size',
        letters: 'Letters',
        random: 'Random',
        regenerate: 'Regenerate',
        wordTooLong: 'The word "{{word}}" is too long for the grid. Increase the grid size.',
        gridTooCrowded: 'Words don\'t fit in the grid. Increase the grid size.',
        targetWords: 'Words to find',
        wordInputPlaceholder: 'Enter a word...',
        wordFindable: 'Can be built from the grid',
        wordNotFindable: 'Cannot be built from the grid',
        someUnfindable: 'Some words cannot be built from this grid. Check the letters or change the words.',
        timeLimit: 'Time per game',
        timeSec: 'sec',
        timeMin: 'min',
        timeHintMin: 'From 1 to 60 minutes. Timer starts on the student\'s first click.',
        timeHintSec: 'From 10 to 3600 seconds. Timer starts on the student\'s first click.',
        minWordsToPass: 'Minimum words to "pass"',
        minWordsHint: 'If the student finds at least this many, the result is positive.',
        addAtLeastOneWord: 'Add at least one word to find',
      },
      chooseWord: {
        title: 'Choose word',
        subtitle: 'Inside square brackets write two options separated by /. Example:',
        instructionPlaceholder: 'E.g. Pick the correct option',
        sentences: 'Sentences',
        sentencePlaceholder: 'I [go/goes] to school every day.',
        deleteSentence: 'Delete',
        addSentence: 'Add sentence',
        addOptionsFormat: 'Add options in the format',
        highlightColor: 'Option outline color',
        selectedFillColor: 'Selected option fill',
        selectedTextColor: 'Selected option text color',
      },
      fixMistake: {
        title: 'Fix the mistake',
        subtitle: 'Wrap the wrong word in square brackets, add the correct answer after |. Multiple accepted corrections — also via |. Example:',
        instructionPlaceholder: 'E.g. Find and fix the mistake',
        sentences: 'Sentences',
        deleteSentence: 'Delete',
        addSentence: 'Add sentence',
        addMistakeFormat: 'Mark the mistake in the format',
        mistake: 'Mistake',
        noCorrection: 'Add the correct answer after |',
        hint: 'The student sees the sentence with no hints — taps the word they think is wrong and types the correction.',
        highlightColor: 'Correction highlight color',
      },
      dragLabelBlank: {
        title: 'Labels on slide',
        subtitle: 'Place slots anywhere on the slide. Students drag labels from the panel.',
        slotPlacement: 'Slot placement',
        clickToAddSlot: 'Click to add a slot',
        placeholderLabel: '+ label',
        placementHint: 'Click on the slide preview to add a slot. Drag to move.',
        labelTextStyle: 'Label text style',
        labelColor: 'Label color',
        labelTextColor: 'Label text color',
        slotColor: 'Slot color',
        paletteColor: 'Answers panel color',
      },
      dragLabelImage: {
        title: 'Drag labels onto image',
        subtitle: 'The student drags labels onto the correct spots on the image',
        image: 'Image',
        placementHint: 'Click the image to add a slot. Drag slots to move them.',
        cropHint: 'Drag the rectangle to crop the image. Corners resize.',
        placeholderLabel: '+ label',
        done: 'Done',
        cancel: 'Cancel',
        crop: 'Crop',
        resetCrop: 'Reset crop',
        changeImage: 'Change',
        deleteImage: 'Delete',
        paletteSideLabel: 'Palette position',
        labelTextStyle: 'Label text style',
        labelColor: 'Label color',
        labelTextColor: 'Label text color',
        slotColor: 'Slot color',
      },
      nmtImage: {
        title: 'NMT picture',
        subtitle: 'Upload pictures and add lettered options (A, B, C…). Pick the correct answer for each picture.',
        options: 'Answer options ({{count}})',
        addOption: 'Add option',
        addAtLeastTwoOptions: 'Add at least two options',
        questions: 'Pictures ({{count}})',
        addImage: 'Add picture',
        addFirstImage: 'Click "Add picture" to upload the first one.',
        imageNumber: 'Picture #{{index}}',
        replaceImage: 'Replace picture',
        promptPlaceholder: 'Question or hint (optional)',
        correctAnswer: 'Correct answer',
        noCorrectAnswer: '— pick an option —',
        needCorrect: 'Pick the correct option for this picture',
        correctIs: 'Correct: {{letter}}',
        buttonColor: 'Button color',
      },
      findObject: {
        title: 'Find the object',
        subtitle: 'Upload an image and click on the objects to find. Enter a word for each.',
        image: 'Image',
        placementHint: 'Click the image to add an object. Drag points to move them.',
        clickImageToAdd: 'Click the image to add the first object.',
        cropHint: 'Drag the rectangle to crop the image. Corners resize.',
        done: 'Done',
        cancel: 'Cancel',
        crop: 'Crop',
        resetCrop: 'Reset crop',
        changeImage: 'Change',
        deleteImage: 'Delete',
        objects: 'Objects ({{count}})',
        wordPlaceholder: 'e.g. apple',
        radius: 'Radius',
        wordTextStyle: 'Word text style',
        wordBgColor: 'Word background color',
        shuffleTitle: 'Shuffle order',
        shuffleOn: 'Objects appear in random order',
        shuffleOff: 'Objects appear in list order',
      },
      findSticker: {
        title: 'Find the sticker',
        subtitle: 'Upload an image, add stickers and give each one a word. The student reads the word and taps the matching sticker.',
        image: 'Image',
        placementHint: 'Drag stickers to reposition them on the image.',
        addFirst: 'Click "Add sticker" to place the first one.',
        cropHint: 'Drag the rectangle to crop the image. Corners resize.',
        done: 'Done',
        cancel: 'Cancel',
        crop: 'Crop',
        resetCrop: 'Reset crop',
        changeImage: 'Change',
        deleteImage: 'Delete',
        addSticker: 'Add sticker',
        stickers: 'Stickers ({{count}})',
        wordPlaceholder: 'e.g. apple',
        size: 'Size',
        wordTextStyle: 'Word text style',
        wordBgColor: 'Word background color',
        shuffleTitle: 'Shuffle order',
        shuffleOn: 'Stickers appear in random order',
        shuffleOff: 'Stickers appear in list order',
      },
      dragLabelText: {
        title: 'Drag labels into text',
        subtitle: 'The student drags labels into gaps in the text',
        text: 'Text',
        addGap: 'Add gap',
        insertGapTooltip: 'Insert a gap at the cursor position',
        textPlaceholder: 'Enter a sentence. Click "Add gap" to insert a slot for a label.',
        gapsHint: 'Gaps appear as',
        inTheText: 'in the text',
        gaps: 'Gaps ({{count}})',
        deleteGap: 'Delete gap',
        textColor: 'Text color',
        slotColor: 'Gap color',
        labelColor: 'Label color',
        labelTextColor: 'Label text color',
        paletteColor: 'Answers panel color',
      },
      fillGaps: {
        title: 'Fill the gaps',
        subtitle: 'The student types answers into gaps in the text',
        text: 'Text',
        addGap: 'Add gap',
        insertGapTooltip: 'Insert a gap at the cursor position',
        boldTooltip: 'Bold (select text → press B)',
        italicTooltip: 'Italic (select text → press I)',
        textPlaceholder: 'Enter a sentence. Place the cursor and click "Add gap".',
        formatsHint: 'Gaps: {{gaps}}. Bold: {{bold}}. Italic: {{italic}}',
        gaps: 'Gaps ({{count}})',
        gapNumber: 'Gap #{{index}}',
        deleteGap: 'Delete gap',
        deleteOption: 'Delete option',
        optionPlaceholder: 'Option {{index}}',
        addOption: 'Another option',
        multipleAnswersHint: 'Any of the options counts as correct. Case and spaces are ignored.',
        textColor: 'Text color',
        gapTextColor: 'Gap text color',
        gapBorderColor: 'Gap border color',
        gapBgColor: 'Gap background',
        validation: 'Add at least one correct answer for each gap',
      },
      dressUp: {
        title: 'Dress-up',
        subtitle: 'A character and a wardrobe. The student dresses the character — one item per category. Transparent PNGs work best.',
        heading: 'Title',
        character: 'Character',
        categories: 'Wardrobe',
        layerHint: 'Lower categories are drawn on top of higher ones (e.g. a jacket over a T-shirt).',
        categoryPlaceholder: 'Category name (Hats, Tops…)',
        removeCategory: 'Remove category',
        itemPlaceholder: 'Item name (a red hat)',
        place: 'Place on the character',
        removeItem: 'Remove item',
        addItem: 'Item',
        bulkUpload: 'Several files',
        addCategory: 'Add category',
        showNames: 'Show item names',
        accentColor: 'Accent',
        panelBgColor: 'Wardrobe background',
        textColor: 'Text color',
      },
      kissMarryAvoid: {
        subtitle: 'Three characters. The student gives each one of the three options — every option can go to only one character.',
        heading: 'Title',
        headingPlaceholder: 'Kiss, Marry or Avoid?',
        characters: 'Characters',
        characterNumber: 'Character {{index}}',
        namePlaceholder: 'Name (optional if there is a photo)',
        upload: 'Upload',
        photoLibrary: 'Photos',
        options: 'Options',
        cardBgColor: 'Card background',
        textColor: 'Text color',
      },
      boardGame: {
        title: 'Board game',
        subtitle: 'Players take turns rolling the die and moving along the cells. Each cell holds a task. A cell can send you forward or back.',
        heading: 'Title',
        players: 'Players',
        addPlayer: 'Add player',
        startLabel: 'Start',
        finishLabel: 'Finish',
        cells: 'Task cells ({{count}})',
        cellPlaceholder: 'Task (e.g. Name 3 fruits)',
        jump: 'Jump',
        noJump: 'none',
        image: 'Image',
        addCell: 'Add cell',
        columns: 'Cells per row: {{count}}',
        boardColor: 'Board background',
        cellColor: 'Cell background',
        accentColor: 'Start / finish',
        textColor: 'Text color',
      },
      spotDifference: {
        title: 'Spot the difference',
        subtitle: 'Two similar pictures of the same size. Click to mark the differences — the student looks for them on either picture.',
        heading: 'Title',
        imageA: 'Picture 1',
        imageB: 'Picture 2',
        markHint: 'Click a difference ({{count}})',
        size: 'Size',
        layout: 'Layout',
        horizontal: 'Side by side',
        vertical: 'Stacked',
        markerColor: 'Marker color',
        textColor: 'Text color',
      },
      mindMap: {
        subtitle: 'Topic in the centre, branches and ideas around it. During the lesson the student adds their own with the “+” button.',
        center: 'Central topic',
        allowAdd: 'Student can add branches and ideas',
        branches: 'Branches ({{count}})',
        branchesHint: 'You can leave it empty — the student builds the map from scratch.',
        branchPlaceholder: 'Branch (e.g. Transport)',
        leafPlaceholder: 'Idea (e.g. by plane)',
        addLeaf: 'Idea',
        addBranch: 'Add branch',
        centerColor: 'Centre background',
        centerTextColor: 'Centre text',
        nodeBgColor: 'Idea background',
        textColor: 'Text color',
      },
      dialogue: {
        title: 'Dialogue simulator',
        subtitle: 'The character says a line — the student picks a reply. A wrong reply does not move the dialogue on. For branching, choose where each reply leads.',
        characterName: 'Character name',
        subtitleField: 'Caption',
        avatar: 'Avatar',
        steps: 'Dialogue steps ({{count}})',
        stepNumber: 'Step {{index}}',
        botTextPlaceholder: 'What the character says',
        markWrong: 'Mark as wrong',
        markCorrect: 'Mark as correct',
        optionPlaceholder: 'Student reply',
        replyPlaceholderCorrect: 'Character reaction (optional)',
        replyPlaceholderWrong: 'Reaction to the mistake (e.g. Sorry, what?)',
        goesTo: 'Next:',
        nextInList: 'next step',
        endDialogue: 'end of dialogue',
        addOption: 'Reply option',
        addStep: 'Add step',
        autoSpeak: 'Read character lines aloud automatically',
        voice: 'Voice',
        botBubbleColor: 'Character bubbles',
        botTextColor: 'Character text',
        myBubbleColor: 'Student bubbles',
        myTextColor: 'Student text',
      },
      pictionary: {
        subtitle: 'One player draws a secret word, the other guesses out loud. Only the artist sees the word.',
        mode: 'Mode',
        modeDuo: 'Student ↔ teacher',
        modeTeams: 'Teams',
        modeTeamsHint: 'The teacher hosts: sees the word and awards points. The team artist peeks at the word with the “Hold” button.',
        modeDuoHint: 'Student and teacher take turns drawing. The artist scores a point when the word is guessed.',
        teams: 'Teams',
        addTeam: 'Add team',
        firstDrawer: 'Draws first',
        words: 'Words — one per line ({{count}})',
        roundSeconds: 'Round time: {{count}} s',
        canvasColor: 'Canvas background',
        accentColor: 'Accent',
      },
      personalityQuiz: {
        title: 'Personality quiz',
        subtitle: 'The student answers one question at a time. Each answer gives a point to one of the results — the result with the most points is shown at the end.',
        quizTitle: 'Title',
        quizTitlePlaceholder: 'Which princess are you?',
        results: 'Results ({{count}})',
        resultNumber: 'Result {{letter}}',
        deleteResult: 'Delete result',
        resultTitlePlaceholder: 'Title (e.g. You are Cinderella!)',
        resultDescriptionPlaceholder: 'Result text',
        resultsHint: 'What the student sees at the end, depending on which answers they picked most.',
        resultIf: 'If mostly «{{letter}}» →',
        previewResult: 'Show this result on the slide',
        addResult: 'Add result',
        questions: 'Questions ({{count}})',
        questionNumber: 'Question #{{index}}',
        deleteQuestion: 'Delete question',
        questionPlaceholder: 'Question',
        optionPlaceholder: 'Answer option',
        deleteOption: 'Delete option',
        addOption: 'Add option',
        addQuestion: 'Add question',
        givesPointTo: '+1 point to result',
        noResult: '— result —',
        unassignedWarning: 'Some answers are not linked to a result — they give no points.',
        emptyHint: 'Add results and questions in the settings on the right',
        accentColor: 'Accent color',
        optionBgColor: 'Option background',
        textColor: 'Text color',
      },
      memory: {
        title: 'Memory',
        subtitle: 'The student flips cards and finds matching pairs: word ↔ image. You can also use text-only or image-only pairs.',
        pairs: 'Pairs ({{count}})',
        pairNumber: 'Pair #{{index}}',
        deletePair: 'Delete pair',
        addPair: 'Add pair',
        textPlaceholder: 'Word',
        addAtLeastTwoPairs: 'Add at least two pairs',
        addPairsHint: 'Add pairs in the settings on the right',
        columns: 'Columns',
        columnsAuto: 'auto',
        columnsHint: '0 = auto. Cards on the board: {{count}}.',
        cardBackColor: 'Card back color',
        cardFrontColor: 'Card front color',
        matchedBorderColor: 'Matched border',
        textColor: 'Text color',
      },
      matchLines: {
        title: 'Match with lines',
        subtitle: 'The student connects dots into pairs. Left column in original order, right column shuffled.',
        pairs: 'Pairs ({{count}})',
        addPair: 'Add pair',
        pairNumber: 'Pair #{{index}}',
        deletePair: 'Delete pair',
        leftPlaceholder: 'Left',
        rightPlaceholder: 'Right',
        topPlaceholder: 'Top',
        bottomPlaceholder: 'Bottom',
        layout: 'Layout',
        layoutHorizontal: 'Left ↔ right',
        layoutVertical: 'Top ↕ bottom',
        uploadImageTooltip: 'Click or drop a file here',
        uploadAudioTooltip: 'Click to upload audio',
        uploading: 'Uploading...',
        dropFile: 'Drop the file',
        picture: 'Picture',
        sticker: 'Sticker',
        stickerTooltip: 'Choose from stickers',
        audio: 'Audio',
        deleteAudio: 'Delete audio',
        invalidAudio: 'Allowed formats: MP3, WAV, OGG, M4A',
        fileTooLarge50: 'Max size: 50MB',
        uploadAudioError: 'Could not upload audio',
        addAtLeastTwoPairs: 'Add at least two pairs',
        allowRetryCheckbox: 'Allow retry',
        columnWidths: 'Column widths ({{left}}% / {{right}}%)',
        leftLabel: 'Left',
        rightLabel: 'Right',
        reset5050: 'Reset to 50% / 50%',
        lineColor: 'Line color',
        dotColor: 'Dot color',
        leftBg: 'Left background',
        rightBg: 'Right background',
        leftText: 'Left text color',
        rightText: 'Right text color',
      },
      labelImage: {
        title: 'Label the image',
        subtitle: 'The student connects word labels to dots marked on the image.',
        image: 'Image',
        uploadImage: 'Upload image',
        replaceImage: 'Replace',
        dropFile: 'Drop the file',
        dropHint: 'or drag a file here',
        sticker: 'Sticker',
        pickSticker: 'Pick from stickers',
        addDot: 'Add dot',
        clickOnImage: 'Click on the image…',
        dragHint: 'Drag the dots to reposition them.',
        items: 'Labels',
        labelNumber: 'Label #{{index}}',
        deleteLabel: 'Delete',
        labelPlaceholder: 'Word (e.g. Deltoid)',
        sideLeft: 'Left',
        sideRight: 'Right',
        color: 'Color',
        addLabel: 'Add label',
        addFirstHint: 'Add a label — a dot appears in the middle of the image. Then drag it.',
        allowRetryCheckbox: 'Allow retry',
        dotSize: 'Dot size',
        lineColor: 'Line color (fallback)',
        dotFill: 'Dot fill',
        dotBorder: 'Dot border',
      },
      oddOneOut: {
        title: 'Odd one out',
        subtitle: 'The student picks the odd item in each row. 1 point per correct row.',
        rowNumber: 'Row {{index}}',
        onePoint: '· 1 point',
        deleteRow: 'Delete row',
        itemCount: 'Number of items',
        itemsLabel: 'Items (click the circle on the left to mark the odd one)',
        oddMarker: 'Odd',
        markAsOdd: 'Mark as odd',
        text: 'Text',
        audio: 'Audio',
        itemPlaceholder: 'Word {{index}}',
        deleteAudio: 'Delete audio',
        uploading: 'Uploading...',
        uploadAudio: 'Upload audio',
        explanation: 'Explanation',
        explanationHelp: '(shown after answer)',
        explanationPlaceholder: 'For example: "Chair" is not a fruit',
        addRow: 'Add row',
        invalidAudio: 'Allowed formats: MP3, WAV, OGG, M4A',
        fileTooLarge50: 'Max size: 50MB',
        uploadAudioError: 'Could not upload audio',
        alignment: 'Alignment',
        alignLeft: 'Left',
        alignCenter: 'Center',
        alignRight: 'Right',
      },
      pronounce: {
        targetLabel: 'Word or phrase to pronounce',
        targetPlaceholder: 'E.g.: apple',
        listen: 'Listen',
        recognitionLanguage: 'Recognition language',
        starsForAccuracy: 'Stars by pronunciation accuracy',
        accuracyHeader: 'Accuracy (0.0–1.0) ≥',
        starsHeader: 'Stars',
        accuracyHint: 'Accuracy = how well the recognized word matches the reference (1.0 = perfect). Web Speech API recognizes words but does not judge stress/intonation.',
        allowRetry: 'Allow retry',
        showTargetToStudent: 'Show the word spelling to the student',
        appearance: 'Appearance',
        wordFontSize: 'Word text size',
        wordFont: 'Font',
        wordColor: 'Word text color',
        micButtonColor: 'Mic button color',
        bottomBarColor: 'Bottom bar color',
        langEnUS: 'English (US)',
        langEnGB: 'English (UK)',
        langUkUA: 'Ukrainian',
        langRuRU: 'Russian',
        langPlPL: 'Polish',
        langDeDE: 'German',
        langFrFR: 'French',
        langEsES: 'Spanish',
        langItIT: 'Italian',
      },
      sorting: {
        title: 'Sorting',
        subtitle: 'The student drags items into the correct categories. 1 point per correctly sorted item.',
        layout: 'Layout',
        baskets: 'Baskets',
        table: 'Table',
        paletteSide: 'Element pool position',
        top: 'Top',
        bottom: 'Bottom',
        left: 'Left',
        right: 'Right',
        categoriesLabel: 'Categories',
        categoryDefault: 'Category {{index}}',
        categoryColor: 'Category color',
        categoryPlaceholder: 'Category name',
        deleteCategory: 'Delete category',
        addCategory: 'Add category',
        itemsLabel: 'Items to sort',
        addCategoryFirst: 'Add at least one category first.',
        itemPlaceholder: 'Item {{index}}',
        correctCategory: 'Correct category',
        noName: 'Untitled',
        categoryChoice: '— Category —',
        addItem: 'Add item',
        primaryCategoryColor: 'Primary category color',
        itemBg: 'Item background',
      },
      tableFill: {
        title: 'Fill the table',
        subtitle: 'Pencil cells are filled in by the student, eye cells are visible right away. 1 point per correctly filled cell.',
        cells: 'Cells',
        legendGiven: 'Visible to student',
        legendAnswer: 'Student types',
        alternativesHint: 'A pencil cell\'s text is the correct answer. Separate alternatives with |. Empty cells are not graded.',
        inputBg: 'Answer cell background',
        validation: 'Mark at least one answer cell with the pencil',
      },
      table: {
        title: 'Table',
        subtitle: 'Click a cell to enter text',
        rows: 'Rows ({{count}})',
        columns: 'Columns ({{count}})',
        firstRowHeader: 'First row is header',
        borderWidth: 'Border width ({{width}}px)',
        borderColor: 'Border color',
        cellBg: 'Cell background',
        headerBg: 'Header background',
        headerText: 'Header text',
      },
      puzzle: {
        title: 'Puzzle',
        subtitle: 'Upload an image and pick a grid. Arrange the pieces anywhere on the slide — the student drags them into the frame.',
        image: 'Image',
        uploadImage: 'Upload image',
        changeImage: 'Change',
        deleteImage: 'Delete',
        gridSize: 'Grid size',
        rows: 'Rows',
        cols: 'Columns',
        totalPieces: '{{count}} pieces',
        regenerate: 'Regenerate shape & scatter',
        frameColor: 'Target frame color',
        tip: 'Drag the frame and pieces directly on the slide. Resize the frame by its bottom-right corner — aspect ratio stays locked to the image.',
      },
      abcd: {
        title: 'ABCD',
        subtitle: 'Questions with 2–4 options. The student circles the correct one, the teacher presses "Check"',
        instructionPlaceholder: 'e.g. Choose the correct answer',
        addQuestion: 'Add question',
        importButton: 'Import as text',
        importHint: 'Put each question on its own line with options a) b) c) d) below. Mark the correct one with * at the end. Separate questions with an empty line.',
        loadCurrent: 'Load current questions as text',
        importPreview: 'Questions recognized: {{count}}',
        importCancel: 'Cancel',
        importReplace: 'Replace all',
        importAppend: 'Add',
        importSuccess: 'Questions added: {{count}}',
        questions: 'Questions',
        questionPlaceholder: 'Question {{index}}',
        deleteQuestion: 'Delete question',
        optionPlaceholder: 'Option {{letter}}',
        addOption: 'Add option',
        deleteOption: 'Delete option',
        markCorrect: 'Mark as correct',
        correctHint: 'Click a letter to mark the correct answer.',
        layout: 'Options layout',
        layoutRow: 'In a row',
        layoutColumn: 'In a column',
        circleColor: 'Circle color',
        validation: 'Add at least one question',
        emptyOptions: 'Empty options: {{count}}',
      },
      trueFalse: {
        title: 'True / False',
        subtitle: 'Students write T (true), F (false){{extra}} in the boxes',
        subtitleExtra: ', N (no information)',
        instructionPlaceholder: 'E.g. Read the statement and mark T, F or N',
        variantN: 'Option "N" (no information)',
        variantNOnDesc: 'Students can choose T, F or N',
        variantNOffDesc: 'Only T or F',
        lettersLabel: 'Answer letters',
        lettersDuplicate: 'Letters must be different',
        roleT: 'True',
        roleF: 'False',
        roleN: 'No info',
        statements: 'Statements',
        statementPlaceholder: 'Statement {{index}}',
        addStatement: 'Add statement',
        deleteStatement: 'Delete',
        audioLabel: 'Audio (optional)',
        addAudio: 'Add audio',
        deleteAudio: 'Delete audio',
        uploadingAudio: 'Uploading…',
        invalidAudio: 'Please choose an audio file',
        fileTooLarge: 'Maximum file size is 50 MB',
        uploadAudioError: 'Failed to upload audio',
        boxBg: 'Box background',
        boxBorderColor: 'Box border color',
        letterColor: 'Answer color (T/F)',
        validation: 'Add at least one statement',
      },
      typeAnswer: {
        title: 'Type the answer',
        subtitle: 'The student types an answer in a text field',
        question: 'Question',
        questionPlaceholder: 'Enter a question...',
        correctAnswers: 'Correct answers',
        answerPlaceholder: 'Option {{index}}',
        addOption: 'Add option',
        deleteOption: 'Delete',
        answersHint: 'Any option counts as correct. Case and trimmed spaces are ignored.',
        placeholderLabel: 'Field placeholder',
        placeholderPlaceholder: 'Enter answer...',
        inputBg: 'Input field background',
        inputTextColor: 'Input text color',
        inputBorderColor: 'Input field border color',
        validation: 'Add at least one correct answer',
      },
      missingLetters: {
        title: 'Missing letters',
        subtitle: 'Type a word and click letters to hide them. The student types them into the empty boxes.',
        word: 'Word',
        wordPlaceholder: 'e.g. apple',
        toggleHint: 'Click a letter to hide or show it',
        autoPick: 'Auto',
        clear: 'Show all',
        hiddenCount: 'Hidden: {{count}}',
        showLetter: 'Show letter',
        hideLetter: 'Hide letter',
        hint: 'Hint',
        hintOptional: '(optional)',
        hintPlaceholder: 'e.g. fruit, double p',
        tileBg: 'Visible letter background',
        inputBg: 'Empty box background',
        inputBorderColor: 'Empty box border color',
        validationWord: 'Enter a word',
        validationHidden: 'Hide at least one letter',
      },
      rank: {
        title: 'Rank',
        subtitle: 'The student arranges items from first to last. 1 point per correct position.',
        layout: 'Layout',
        vertical: 'Vertical',
        horizontal: 'Horizontal (steps)',
        itemsLabel: 'Items in the correct order',
        orderHint: 'Position #1 is the item the student should place first.',
        itemPlaceholder: 'Item {{index}}',
        addItem: 'Add item',
        moveUp: 'Move up',
        moveDown: 'Move down',
        endLabels: 'End labels (optional)',
        topLabelPlaceholder: 'Top label (e.g. "Largest")',
        bottomLabelPlaceholder: 'Bottom label (e.g. "Smallest")',
        slotColor: 'Slot color',
        itemBg: 'Item background',
        showNumbers: 'Position numbering',
        showNumbersOn: 'Show 1, 2, 3…',
        showNumbersOff: 'No numbering',
      },
      unjumble: {
        title: 'Unjumble sentence',
        subtitle: 'The student drags words to build the sentence in the right order.',
        bonusPerSentence: ' 1 point per correct sentence.',
        correctSentences: 'Correct sentences',
        sentenceNumber: 'Sentence {{index}}',
        wordSingular: 'word',
        wordPlural: 'words',
        deleteSentence: 'Delete sentence',
        sentencePlaceholder: 'The cat sat on the mat.',
        addSentence: 'Add sentence',
        wordsShuffleHint: 'Words are shuffled automatically. The student gets 1 point for each correctly built sentence.',
        hint: 'Hint',
        hintOptional: '(optional)',
        hintPlaceholder: 'E.g.: past simple, question form',
        tileBg: 'Word background',
        tileBorderColor: 'Word border color',
        alignment: 'Alignment',
        alignLeft: 'Align left',
        alignCenter: 'Align center',
        alignRight: 'Align right',
        showNumbers: 'Sentence numbering',
        showNumbersOn: 'Sentences are numbered (1., 2., 3. …)',
        showNumbersOff: 'No numbering',
        numberColor: 'Number color',
      },
      orderSentences: {
        title: 'Order sentences',
        subtitle: 'The student drags sentences in a column to put them in the correct order. 1 point per correct position.',
        correctOrder: 'Sentences in the correct order',
        positionLabel: 'Position {{index}}',
        moveUp: 'Move up',
        moveDown: 'Move down',
        deleteSentence: 'Delete sentence',
        sentencePlaceholder: 'E.g.: I wake up at seven.',
        addSentence: 'Add sentence',
        shuffleHint: 'Sentences are shuffled automatically. The student has to drag them into the correct order.',
        hint: 'Hint',
        hintOptional: '(optional)',
        hintPlaceholder: 'E.g.: typical daily routine',
        tileBg: 'Sentence background',
        tileBorderColor: 'Border color',
        alignment: 'Alignment',
        alignLeft: 'Align left',
        alignCenter: 'Align center',
        alignRight: 'Align right',
        showNumbers: 'Position numbering',
        showNumbersOn: 'Positions are numbered (1., 2., 3. …)',
        showNumbersOff: 'No numbering',
        numberColor: 'Number color',
      },
      wordPool: {
        title: 'Boggle',
        subtitle: 'The student builds words from letters in the pool. No adjacency required — any letter, each once per word.',
        gameMode: 'Game mode',
        modeTime: 'Timed',
        modeTargets: 'Find targets',
        modeTimeHint: 'The student finds as many English words as possible in the given time (checked against a dictionary).',
        modeTargetsHint: 'The student has to find all target words from the letter pool.',
        letterCount: 'Number of letters',
        layout: 'Letter layout',
        layoutCloud: 'Cloud',
        layoutRow: 'Row',
        layoutSquare: 'Square',
        layoutCircle: 'Circle',
        letters: 'Letters ({{count}})',
        random: 'Random',
        addLetter: '+ letter',
        addLettersHint: 'Add letters',
        targetWords: 'Words to find',
        wordInputPlaceholder: 'Enter a word...',
        wordFindable: 'Can be built from the pool',
        wordNotFindable: 'Cannot be built — not enough letters',
        someUnfindable: 'Some words are missing letters in the pool. Add letters or change the words.',
        timeLimit: 'Time per game',
        timeSec: 'sec',
        timeMin: 'min',
        timeHintMin: 'From 1 to 60 minutes. Timer starts on the student\'s first click.',
        timeHintSec: 'From 10 to 3600 seconds. Timer starts on the student\'s first click.',
        minWordsToPass: 'Minimum words to "pass"',
        minWordLength: 'Minimum word length',
        addAtLeastOneWord: 'Add at least one word to find',
      },
    },
    exerciseConfig: {
      singleChoiceTitle: 'Single answer',
      multipleChoiceTitle: 'Multiple answers',
      singleChoiceSubtitle: 'Student can pick only one option',
      multipleChoiceSubtitle: 'Student can pick multiple options',
      question: 'Question',
      questionPlaceholder: 'Enter a question...',
      answerOptions: 'Answer options ({{count}}/6)',
      addOption: 'Add',
      correctAnswer: 'Correct answer',
      markAsCorrect: 'Mark as correct',
      deleteOption: 'Delete option',
      pickAtLeastOneCorrect: 'Pick at least one correct answer',
      retryTitle: 'Retry',
      retryOn: 'Student can try again',
      retryOff: 'Only one attempt',
      questionTextColor: 'Question text color',
      questionBgColor: 'Question background',
      optionsTextColor: 'Options text color',
      optionsBgColor: 'Options background',
    },
    richText: {
      boldTitle: 'Bold (Ctrl+B)',
      italicTitle: 'Italic (Ctrl+I)',
      underlineTitle: 'Underline (Ctrl+U)',
      insertTable: 'Insert table',
      addRow: 'Add row',
      deleteRow: 'Delete row',
      addColumn: 'Add column',
      deleteColumn: 'Delete column',
      insertImage: 'Insert image',
      selectAndBoldHint: 'Select text and press B for bold',
      selectAndFormatHint: 'Select text and apply formatting',
      imageTooLarge: 'Image is too large. Maximum size: 5MB',
      defaultPlaceholder: 'Enter text...',
    },
    lessonGames: {
      pageTitle: 'Review games',
      teacherOwnLessons: 'My lessons',
      back: 'Back',
      addGame: 'Add game',
      bindFromLibrary: 'Add from library',
      pickFromLibrary: 'Pick a game from the library',
      libraryEmpty: 'The library is empty. Create games in the "Repetition games" tab.',
      createInTabHint: 'Create new games in the "Repetition games" tab — this page only attaches library games to the lesson.',
      noBoundGames: 'No games attached to this lesson yet',
      noBoundGamesHint: 'Click "Add from library" to attach one.',
      bindAction: 'Attach',
      unbind: 'Detach',
      unbindTitle: 'Detach game?',
      unbindConfirm: 'Detach "{{name}}" from this lesson? The game itself will stay in the library.',
      noGames: 'No games yet',
      noGamesHint: 'Press "Add game" to create the first one',
      pickGameType: 'Pick a game type',
      preview: 'Preview game',
      edit: 'Edit',
      close: 'Close',
      titleLabelOptional: 'Title (optional)',
      titlePlaceholder: 'e.g. {{label}} — lesson 3',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving…',
      deleteTitle: 'Delete game?',
      deleteConfirm: 'Delete game "{{name}}"? This action cannot be undone.',
      createFailedTitle: 'Failed to create game',
      createFailedMessage: 'Check that the backend is running and try again.',
      gameTypes: {
        memoryDesc: 'Match pairs: word ↔ image',
        labelledDiagramDesc: 'Drag labels to the correct points on the image',
        pairOrNoPairDesc: 'Decide whether two cards go together',
        listenTypeDesc: 'Listen to audio and type what you hear',
        listenPickImageDesc: 'Listen to a word and pick the correct image',
        sortingDesc: 'Drag words into the right boxes/baskets/bins',
        dictationDesc: 'Ken pronounces a phrase — the student writes it down',
        findObjectDesc: 'Find the object in the image by its name',
        pickPronunciationDesc: 'Pick the icon that pronounces the written word',
        listenPickWordDesc: 'Listen and pick which of two words you hear',
        sunscreenDesc: 'Student applies sunscreen to parts of Ken (for body / beach topics)',
        thisOrThatDesc: 'Question in the middle, two options below — the student picks the right one',
        spellPictureDesc: 'Image + dashes: student types the word letter by letter',
      },
    },
    programEditor: {
      title: 'Program editor',
      back: 'Back',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      add: 'Add',
      titleLabel: 'Title',
      descriptionLabel: 'Description',
      levelLabel: 'Level',
      ageCategoryLabel: 'Age category',
      lessonsHeading: 'Lessons',
      modulesHeading: 'Modules',
      addModule: 'Add module',
      addLesson: 'Add lesson',
      newModuleTitle: 'New module title',
      newLessonTitle: 'Lesson title',
      newLessonDescription: 'Lesson description',
      presentation: 'Presentation',
      homework: 'Homework',
      specialLessons: 'Special lessons',
      repetitionLessons: 'Repetition lessons',
      moduleTest: 'Module test',
      matchingMetadata: 'Matching metadata',
      frequency: 'Frequency',
      englishType: 'English type',
      ageMin: 'Min age',
      ageMax: 'Max age',
      gender: 'Gender',
      topics: 'Topics',
      learningGoal: 'Learning goal',
      overrideWeights: 'Override weights',
      weightsLabels: {
        level: 'Level',
        age: 'Age',
        topics: 'Topics',
        learningGoal: 'Goal',
        frequency: 'Frequency',
        englishType: 'English type',
      },
      errorTitle: 'Error',
      successTitle: 'Success',
      alerts: {
        stillLoading: 'The program is still loading. Wait a few seconds and try again.',
        enterProgramTitle: 'Please enter the program title',
        pickLevel: 'Please pick a level',
        ageFromGreaterThanTo: 'Age "from" cannot be greater than "to"',
        weightsSumMust100: 'The sum of weights must equal 100 (currently {{sum}})',
        atLeastOneModule: 'Create at least one module',
        allLessonsMustBelongModule: 'Every lesson must belong to a module',
        saveFailed: 'Failed to save the program',
        pickModuleFirst: 'Pick a module first',
        enterLessonTitle: 'Please enter a lesson title',
        enterModuleTitle: 'Enter a module title',
        moduleTitleNotEmpty: 'Module title cannot be empty',
        altModuleLimit: 'Up to 9 alternatives per module',
        altLessonCountMismatch: 'Alternative module "{{title}}" has {{alt}} lessons, primary has {{primary}}. Counts must match.',
        enterCategoryName: 'Enter a category name',
        categoryCreated: 'Category created',
        createCategoryFailed: 'Failed to create the category',
        pickPresentationAndCategory: 'Pick a presentation and a category',
        specialLessonAdded: 'Special lesson added',
        addSpecialLessonFailed: 'Failed to add the special lesson',
        pickPresentation: 'Pick a presentation',
        repetitionLessonAdded: 'Repetition lesson added',
        addRepetitionLessonFailed: 'Failed to add the repetition lesson',
      },
      confirms: {
        deleteLessonTitle: 'Delete lesson?',
        deleteLessonMessage: 'Remove this lesson from the program?',
        deleteModuleTitle: 'Delete module?',
        deleteModuleWithLessons: 'Delete the module and {{count}} {{noun}} inside it?',
        deleteModuleAlone: 'Delete this module?',
        deletePrimaryWithAlternatives: 'Delete this module along with {{count}} alternative modules ({{lessons}} lessons total)?',
        deleteSpecialLessonTitle: 'Delete special lesson?',
        deleteSpecialLessonMessage: 'Remove "{{title}}" from the program?',
        deleteRepetitionLessonTitle: 'Delete repetition lesson?',
        deleteRepetitionLessonMessage: 'Remove "{{title}}" from the program?',
      },
      altModule: {
        addBtn: '+ Alternative module',
        badge: 'Alternative',
        badgeTooltip: 'The teacher will pick one of the alternative modules for each student',
        suffix: 'Alternative',
        descriptionLabel: 'Description (shown to the teacher when choosing)',
        descriptionPlaceholder: 'e.g. suited for active kids who love games',
        groupTitlePlaceholder: 'Module 1',
        groupTitleTooltip: 'Shared module name (common to all alternatives)',
      },
      lessonRow: {
        titleLabel: 'Lesson title *',
        descriptionLabel: 'Lesson description',
        presentationLabel: 'Presentation',
        pickPresentation: 'Pick a presentation...',
        searchPresentation: 'Search presentations...',
        homeworkLabel: 'Homework',
        pickHomework: 'Pick homework...',
        searchHomework: 'Search homework...',
        noResults: 'No matches',
        homeworkStats: '({{exercises}} exercises, {{points}} pts)',
        save: 'Save',
        cancel: 'Cancel',
        presentationPrefix: 'Presentation: {{title}}',
        presentationNone: 'Not selected',
        homeworkPrefix: 'HW: {{title}}',
        homeworkNoneLine: 'Homework: Not selected',
        replayGamesTooltip: 'Replay games',
        editTooltip: 'Edit lesson',
        deleteTooltip: 'Delete lesson',
        repetitionGamesLabel: 'Repetition games',
        repetitionGamesPick: '+ Add a repetition game...',
        repetitionGamesRemove: 'Remove game',
        repetitionGamesSaveHint: 'Save the program first to add repetition games to this lesson.',
      },
      newLesson: {
        heading: 'New lesson',
        titleLabel: 'Lesson title *',
        titlePlaceholder: 'Enter lesson title',
        descriptionLabel: 'Lesson description',
        descriptionPlaceholder: 'Lesson description...',
        presentationLabel: 'Presentation',
        pickPresentation: 'Pick a presentation...',
        homeworkLabel: 'Homework',
        pickHomework: 'Pick homework...',
        createHomeworkHint: 'Create new homework in the "Homework" tab',
        add: 'Add',
        cancel: 'Cancel',
      },
      header: {
        newProgram: 'New program',
        editingProgram: 'Editing program',
        newProgramSubtitle: 'Create a new learning program',
        editingProgramSubtitle: 'Editing: {{title}}',
        cancel: 'Cancel',
        saveTooltip: 'Program is still loading...',
        save: 'Save',
        loadingWarning: 'Loading program... Do not click "Save" until data appears, otherwise you may accidentally overwrite the program with empty content.',
      },
      details: {
        heading: 'Program details',
        nameLabel: 'Program name *',
        namePlaceholder: 'Enter program name',
        descriptionLabel: 'Program description',
        descriptionPlaceholder: 'Add a description...',
        levelLabel: 'Level *',
        pickLevel: 'Pick a level...',
        ageCategoryLabel: 'Age category',
        pickAgeCategory: 'Pick a category...',
        ageChild: 'Child',
        ageTeen: 'Teenager',
        ageAdult: 'Adult',
        nextProgramLabel: 'Next program',
        nextProgramNone: 'Not set',
        nextProgramHint: 'When the student finishes this program, the next one starts automatically in the same schedule slots.',
      },
      matching: {
        heading: 'Matching parameters',
        description: 'Used to automatically pick a program for the student when they sign up for private lessons.',
        frequencyLabel: 'Frequency (times/week)',
        frequencyNotSet: 'Not set',
        frequency2: '2 times',
        frequency3: '3 times',
        englishTypeLabel: 'English type',
        englishTypeNotSet: 'Not set',
        ageFromLabel: 'Age from',
        ageFromPlaceholder: 'e.g. 18',
        ageToLabel: 'Age to',
        ageToPlaceholder: 'e.g. 25',
        topicsLabel: 'Topics',
        topicInputPlaceholder: 'Type a topic and press Enter',
        learningGoalLabel: 'Learning goal',
        advancedHeading: 'Advanced: weights for this program',
        advancedHint: '(defaults use global weights)',
        weightsSumHint: 'Weights must sum to 100%.',
        weightsSum: 'Sum: {{sum}}%',
      },
      lessonsSection: {
        heading: 'Program lessons',
        addModule: 'Add module',
        newModuleHeading: 'New module',
        newModulePlaceholder: 'Module title',
        addModuleBtn: 'Add',
        cancel: 'Cancel',
        noModules: 'No modules',
        noModulesHint: 'Create the first module to add lessons',
        expandTooltip: 'Expand',
        collapseTooltip: 'Collapse',
        lessonCount: '{{count}} {{noun}}',
        editModuleTooltip: 'Edit module',
        duplicateModuleTooltip: 'Duplicate module with all its content',
        duplicateSuffix: '(copy)',
        deleteModuleTooltip: 'Delete module',
        moduleTestLabel: 'Module test:',
        moduleTestNone: '— not selected —',
        newTest: '+ New',
        newTestTooltip: 'Create a new test',
        noLessonsInModule: 'No lessons. Add one or drag from another module.',
        addLesson: 'Add lesson',
      },
      lessonNouns: {
        one: 'lesson',
        few: 'lessons',
        many: 'lessons',
      },
      specialSection: {
        heading: 'Special lessons',
        addBtn: 'Add special lesson',
        description: 'Special lessons (birthdays, holidays, etc.) that the teacher can assign instead of a regular lesson. The program will simply shift.',
        addFormHeading: 'Add special lesson',
        presentationLabel: 'Presentation *',
        pickPresentation: 'Pick a presentation...',
        presentationStats: '({{count}} slides)',
        noPresentations: 'No presentations. Create them in the "Presentations" section.',
        categoryLabel: 'Category *',
        pickCategory: 'Pick a category...',
        newCategoryBtn: '+ New',
        noCategories: 'No categories. Create a new one.',
        newCategoryHeading: 'New category',
        nameUkLabel: 'Name (Ukrainian) *',
        nameUkPlaceholder: 'e.g. Birthday',
        nameEnLabel: 'Name (English)',
        nameEnPlaceholder: 'e.g. Birthday',
        creating: 'Creating...',
        createBtn: 'Create',
        cancel: 'Cancel',
        customTitleLabel: 'Custom title (optional)',
        customTitlePlaceholder: 'If empty, the presentation title will be used',
        addBtnForm: 'Add',
        empty: 'No special lessons',
        emptyHint: 'Add lessons for holidays and special events',
        slideCount: '{{count}} slides',
        deleteTooltip: 'Delete',
      },
      repetitionSection: {
        heading: 'Repetition lessons',
        addBtn: 'Add repetition lesson',
        description: 'Lessons to review material that the teacher can assign instead of a regular lesson. The program will shift.',
        addFormHeading: 'Add repetition lesson',
        presentationLabel: 'Presentation *',
        pickPresentation: 'Pick a presentation...',
        presentationStats: '({{count}} slides)',
        noPresentations: 'No presentations. Create them in the "Presentations" section.',
        customTitleLabel: 'Custom title (optional)',
        customTitlePlaceholder: 'If empty, the presentation title will be used',
        addBtnForm: 'Add',
        cancel: 'Cancel',
        empty: 'No repetition lessons',
        emptyHint: 'Add lessons for material review',
        slideCount: '{{count}} slides',
        deleteTooltip: 'Delete',
      },
    },
    editorView: {
      touchMenuCopy: 'Copy',
      touchMenuDuplicate: 'Duplicate',
      touchMenuPaste: 'Paste',
      touchMenuDelete: 'Delete',
      canvaBlocked: "Canva doesn't allow copying images",
      canvaBlockedHint: 'Download the image from Canva (Share → Download), then drag the file onto the slide or copy it.',
      miroBlocked: "Miro doesn't allow copying images",
      miroBlockedHint: 'Download the image from Miro (Export), then drag the file onto the slide.',
      saveErrorTitle: 'Save error',
      saveErrorMessage: 'If you keep editing, changes will not be saved. Please reload the page.',
      reload: 'Reload',
      loadingPresentation: 'Loading presentation...',
      presentationNotFound: 'Presentation not found',
      unsupportedType: 'Unsupported type',
      frameMediaOnly: 'Only images or videos can be inserted into a frame',
      fileTooLarge: 'File too large',
      maxSize: 'Maximum size: {{size}}',
      errorTitle: 'Error',
      frameUploadFailed: 'Failed to upload media to the frame: {{message}}',
      unsupportedFileType: 'Unsupported file type',
      supportedTypesHint: 'Only image, video, and audio files are supported',
      fileTooLargeForType: 'File too large',
      maxSizeForType: 'Maximum size for {{type}}: {{size}}',
      typeImages: 'images',
      typeVideo: 'video',
      typeAudio: 'audio',
      uploadFailed: 'Error uploading file to the server',
      newText: 'New text',
      imageAlt: 'Image',
      inputPlaceholder: 'Enter your answer...',
      notebookPlaceholder: 'Write here…',
      wheelOption: 'Option {{n}}',
      flipQuestion: 'Question',
      flipAnswer: 'Answer',
      stickerAlt: 'Sticker',
      enterQuestion: 'Enter a question...',
      option: 'Option {{n}}',
      bookCoverDefault: 'My book',
      bookPageDefault: 'Page {{n}}',
      word: 'WORD',
      fruits: 'Fruits',
      vegetables: 'Vegetables',
      apple: 'Apple',
      banana: 'Banana',
      carrot: 'Carrot',
      cucumber: 'Cucumber',
      rankItem1: 'Largest',
      rankItem2: 'Large',
      rankItem3: 'Small',
      rankItem4: 'Smallest',
      answer: 'answer',
      readAndWrite: 'Read the statement and write T, F, or N',
      chooseCorrectAnswer: 'Choose the correct answer',
      pickCorrectVariant: 'Pick the correct option',
      findAndFixMistake: 'Find the mistake in the sentence and fix it',
      word1: 'Word 1',
      translation1: 'Translation 1',
      word2: 'Word 2',
      translation2: 'Translation 2',
      word3: 'Word 3',
      translation3: 'Translation 3',
      word4: 'Word 4',
      imageTooLarge: 'Image too large',
      maxSize10MB: 'Maximum size: 20MB',
      insertedImageAlt: 'Inserted image',
      uploadImageFailed: 'Failed to upload image',
      insertImageFailedTitle: 'Failed to insert image',
      insertImageFailedHint: "Some services (Canva, Miro) don't allow copying images. Try downloading the image to your computer, then copy it.",
      successTitle: 'Success',
      presentationSaved: 'Presentation saved!',
      presentationSaveFailed: 'Failed to save presentation',
      personalizedBanner: 'You are editing a personalized copy for one lesson. The original will not change.',
    },
  },
};

export default dict;
